/* eslint-disable no-confusing-arrow */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/sort-comp */
/* eslint-disable array-callback-return */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { replace, push } from 'react-router-redux';
import clone from 'clone';
import _ from 'lodash';
import moment from 'moment-timezone';
import { required, numericRange } from '@mhub/web-validations';
import { utilities } from '@mhub/securedocuments-sdk-js';
import {
  Button,
  Container,
  Dimmer,
  Divider,
  Dropdown,
  Form,
  Grid,
  Header,
  Icon,
  Label,
  List,
  Loader,
  Message,
  Modal,
  Popup,
} from 'semantic-ui-react';
import { Trans, withTranslation } from 'react-i18next';
import qs from 'qs';

import config from '../../../../config';
// actions
import { fetchM, serverRequestGet } from '../../../actions/fetchM';
import { flashSuccessMessage, flashErrorMessage } from '../../../actions/flash';
import { fetchCancellationReasons } from '../../../actions/cancellationReasons';
import { sdsClient } from '../../../actions/secureDocumentsClient';

// components
import AppForm from '../../../components/AppForm';
import BookingAttachment from '../../../components/BookingAttachment';
import BookingPricingPackage from '../../../components/BookingPricingPackage';
import BookingFeePackage from '../../../components/BookingFeePackage';
import CurrencySymbol from '../../../components/CurrencySymbol';
import EditableBox from '../../../components/EditableBox';
import ESigningModal from '../../../components/SignaturePad/ESigningModal';
import LoanAmount from '../../../components/LoanAmount';
import MarkdownText from '../../../components/MarkdownText';
import SearchStaff from '../../../components/SearchStaff';
import SpecificationTable from '../../../components/SpecificationTable';
import Timestamp from '../../../components/Timestamp';
import CalendarDatePicker from '../../../components/CalendarDatePicker';
import EditPackageModal from '../../../components/EditPackageModal';
import PackagingPricingModal from '../../../components/PackagingPricingModal';
import CustomiseFormulaModal from '../../../components/CustomiseFormulaModal';
import CustomFieldForm from '../../../components/CustomFieldForm';
import EditFeePackageModal from '../../../components/EditFeePackageModal';
import CustomiseFeePackageFormulaModal from '../../../components/CustomiseFeePackageFormulaModal';
import HimsErrorLog from '../../../components/HimsErrorLog';
import BookingNote from '../../../components/BookingNote';
// constants
import BOOKING_STATUSES from '../../../constants/bookingStatuses';
import NOETIC_STATUSES from '../../../constants/noeticStatuses';
import IFCA_STATUSES from '../../../constants/ifcaStatuses';
import INSOFT_STATUSES from '../../../constants/insoftStatuses';
import FIRST_TIME_BUYER from '../../../constants/firstTimeBuyer';
import JDE_STATUSES from '../../../constants/jdeStatuses';
import SRP_LOAN_TYPE from '../../../constants/srpLoan';
import { DEFAULT_BOOKING_FIELD_LIST } from '../../../constants/defaultBookingFields';
import { namespaces, TRANSLATION_FILES } from '../../../constants/translation';
import { matchGroupIDToSrRoleID, hasAnyRequiredRoleIDs } from '../../../constants/srRoleAccess';
// containers
import BookingPayment from '../../BookingPayment';
// modals
import BookingStatusNotes from '../../modals/BookingStatusNotes';
import BookingChangeUnit from '../../modals/BookingChangeUnit';
import TinInvalidModal from '../../modals/TinInvalidModal';
import ModalDateTimeForm from '../../modals/DateTimeForm';
import ViewLarge from '../../modals/ViewLarge';
import ModalNotice from '../../modals/ModalNotice';
// structs
import BOOKING_DEFAULT from '../../../structs/booking';
// utils
import { amountToFixed, fullToAmount, spaFullNumber } from '../../../utils/amount';
import { isNumeric } from '../../../utils/numbers/isNumber';
import { getConstantsLabel, translateModels } from '../../../utils/translation';
import { getItem } from '../../../utils/storage';
import { CU_EXTERNAL_STAFF_ACCESS, CU_STAFF_ACCESS } from '../../../constants/changeUnitsAccesses';
import { titleCase, symbolToSpace } from '../../../utils/strings';
import { calculatePricePerSqm } from '../../../utils/price';
import { isCountryVietnam } from '../../../constants/countries';
import { canEditSourceOfFinance, createdByLabel, isVietnamCompany, paymentMethodOpts, unitQuotaChipLabel, vnChangeUnitBlocked } from '../../../utils/vietnam';
import { reservationBlocked } from '../../../utils/preSalesLaunch';

moment.locale('en-gb');
const isPRS = config.get('prs');
const inputDateFormat = 'DD/MM/YYYY';

const RenderDivider = () => <Divider className="compact" />;
const RenderHiddenDivider = () => <Divider hidden className="compact" />;

class Info extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    token: PropTypes.string,
    auth: PropTypes.shape({
      isAdminBasic: PropTypes.bool,
      isDeveloper: PropTypes.bool,
      isDeveloperStaff: PropTypes.bool,
      isBranchLeader: PropTypes.bool,
      isBranchLeaderSupervisor: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isExternalAgentLeader: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      creditCheckAccess: PropTypes.bool,
      allowEditUnitPrice: PropTypes.bool,
      allowEditUnitDetails: PropTypes.bool,
      companyBranch: PropTypes.shape({
        isExternal: PropTypes.bool,
      }),
      company: PropTypes.shape({
        service_company_id: PropTypes.string,
        countryCode: PropTypes.string,
      }),
    }),
    routeParamsID: PropTypes.string,
    onCheck: PropTypes.func,
    appConfig: PropTypes.shape({
      data: PropTypes.shape({
        noeticIsEnabled: PropTypes.bool,
        lawyerIsEnabled: PropTypes.bool,
        ifcaIsEnabled: PropTypes.bool,
        insoftIsEnabled: PropTypes.bool,
        ragicIsEnabled: PropTypes.bool,
        creditControlIsEnabled: PropTypes.bool,
        externalServiceIsEnabled: PropTypes.bool,
        apieServiceIsEnabled: PropTypes.bool,
        advelsoftIsEnabled: PropTypes.bool,
        himsIsEnabled: PropTypes.bool,
        isUem: PropTypes.bool,
        settings: PropTypes.shape({
          allowStaffEditBookingStatus: PropTypes.bool,
          allowStaffEditBookingStatusCancel: PropTypes.bool,
          bookingHideFirstTimeBuyer: PropTypes.bool,
          disableSoldDateEditing: PropTypes.bool,
          disableCancelledDateEditing: PropTypes.bool,
        }),
      }),
    }),
    fetchNewBooking: PropTypes.func,
    isMobile: PropTypes.bool,
    maUserAffiliateCompanyBranchName: PropTypes.string,
    cancellationReasons: PropTypes.shape({
      data: PropTypes.array,
    }),
    t: PropTypes.func,
    refreshPage: PropTypes.bool,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
    appConfig: state.appConfig,
    cancellationReasons: state.cancellationReasons,
  })
  static defaultCustomerModal = {
    isOpen: false,
    header: '',
    headerIcon: 'warning sign',
    message: '',
    customerID: '',
    bookingCustomerID: '',
    bookingID: '',
    customerName: '',
    type: '',
  };
  static getPropsToState = (props) => {
    const loading = props.loading;
    const data = Object.assign({}, BOOKING_DEFAULT, props.data);
    const bookingPP = props.bookingPP;
    const bookingFP = props.bookingFP;
    const projectBookingCustomFields = props.projectBookingCustomFields || [];
    data.spaAmount = spaFullNumber(data) || data.spaValue; // decimal amount
    data.isCancelPending = true;
    data.isUserCooldown = true;
    if (!data.bankCases) {
      data.bankCases = [];
    } else if (data.bankCases && data.bankCases.length > 0) {
      const soldCases = data.bankCases.filter(bankCase => bankCase.status === 'success_li_issued');
      if (soldCases && soldCases.length > 0) {
        data.selectedBankCaseID = soldCases[0].id;
        data.bankName = soldCases[0].bank.name;
        data.bankerName = soldCases[0].banker.preferredName;
        data.loanAmount = parseInt(soldCases[0].loanAmount, 10);
      }
    }
    if (data.pricePerSqm === 0) {
      if (data.systemPricePerSqm > 0) {
        data.pricePerSqm = data.systemPricePerSqm;
      } else {
        data.pricePerSqm = calculatePricePerSqm(data.spaAmount, data.project, data.projectUnit);
      }
    }
    const errMessages = [];
    const modal = Object.assign({}, Info.defaultCustomerModal);
    const projectCurrencies = data.project.projectCurrency;
    const unitTiers = props.unitTiers || [];
    let globalSettings = {};
    const storeGlobalSettings = getItem(`${config.get('appName')}.globalSettings`);
    if (storeGlobalSettings) {
      try {
        globalSettings = JSON.parse(storeGlobalSettings).data || [];
      } catch (e) {
        Bugsnag.notifyException(e);
      }
    }
    if (globalSettings && globalSettings.defaultHoldDelistUnit && data.projectUnit) {
      data.projectUnit.delistOnHold = globalSettings.defaultHoldDelistUnit;
    }
    data.cuFollowPrevBookingDateIsEnabled = data.project.cuDefaultFollowPrevBookingDateIsEnabled;
    data.cuAttachmentsRequired = data.project.cuAttachmentsRequired;
    const changeProjectID = data.projectID || '';
    return {
      data,
      projectBookingCustomFields,
      oriData: clone(data),
      loading,
      errMessages,
      modal,
      projectCurrencies,
      uploadModalState: false,
      unitTiers,
      globalSettings,
      bookingPP,
      bookingFP,
      isBotSyncing: false,
      isHimsSyncing: false,
      changeProjectID,
    };
  }
  constructor(props) {
    super(props);
    const state = Info.getPropsToState(props);
    const cancellationReasons = props.cancellationReasons ?
      [].concat(props.cancellationReasons.data) : [];
    this.state = {
      ...state,
      cancellationReasons,
      bookingChanges: false,
      isBookingPaymentChanged: false,
      isBookingFeePaymentChanged: false,
      editingBooking: false,
      editingPayment: false,
      bookingStatusModal: false,
      showLarge: false,
      selectedPicture: null,
      slideshow: false,
      showCustomFields: false,
      showSignModal: false,
      showDateTimeModal: false,
      showEditPackageModal: false,
      showCustomiseFormulaModal: false,
      bookingCustomFields: [],
      searchUsersData: [],
      searchUserValue: '',
      isSalesPersonSignature: false,
      documentToken: null,
      uploadModalState: false,
      mpUserLoading: false,
      mpUserDetails: {},
      approvedDatePickerVisible: false,
      cancelledDatePickerVisible: false,
      soldDatePickVisible: false,
      spaSigningDatePickerVisible: false,
      spaStampingDatePickerVisible: false,
      minCancelledDate: null,
      minSoldDate: null,
      validationSvcErrorModalOpen: false,
      validationSvcErrorModalContent: '',
      externalSvcErrorModalOpen: false,
      apieSvcErrorModalOpen: false,
      botSvcErrorModalOpen: false,
      botResyncModalOpen: false,
      himsSvcErrorModalOpen: false,
      showChangeUnit: false,
      loadingProject: false,
      projectOpts: [],
      changeUnitID: '',
      loadingUnit: false,
      unitOpts: [],
      bookingChangeUnitModal: false,
      bookingNotesModuleExpand: false,
      tinInvalidModal: false,
      newBookingStatus: '',
      isUnitChange: false,
      pendingChangeUnitData: null,
    };
    this.validation = {
      spaAmount: createRef(),
      nettSellingPrice: createRef(),
      tierPricingName: createRef(),
      tierPricingDescription: createRef(),
    };
    this.customFieldValidation = {};
    this.customFieldFormRef = createRef();
    this.loanBox = null;
    this.refBookingNote = null;
  }
  componentWillMount() {
    const { store } = this.context;
    store.dispatch(fetchCancellationReasons(false));
  }
  componentWillReceiveProps(nextProps) {
    const state = Info.getPropsToState(nextProps);

    const cancellationReasons = nextProps.cancellationReasons ?
      [].concat(nextProps.cancellationReasons.data) : this.state.cancellationReasons;
    // don't allow state to override data if oriData is same
    if (JSON.stringify(this.state.oriData) === JSON.stringify(state.oriData)) {
      state.data = this.state.data;
      state.changeProjectID = this.state.changeProjectID;
    }
    if (state.data.bookingCustomFields) {
      // setup existing custom fields values in data state
      state.data.bookingCustomFields.forEach((d) => {
        state.data[this.bcfPRefix(d.projectBookingCustomField.name)] = d.value;
        state.data[`${this.bcfPRefix(d.projectBookingCustomField.name)}ID`] = d.id;
        if ((d.projectBookingCustomField.type === 'dropdown' || d.projectBookingCustomField.type === 'dropdown_multi')) {
          state.data[`${this.bcfPRefix(d.projectBookingCustomField.name)}OptionID`] = d.projectBookingCustomFieldOptionID;
          state.data[`${this.bcfPRefix(d.projectBookingCustomField.name)}OptionIDs`] = d.projectBookingCustomFieldOptionIDs;
        } else {
          state.data[`${this.bcfPRefix(d.projectBookingCustomField.name)}OptionID`] = '';
          state.data[`${this.bcfPRefix(d.projectBookingCustomField.name)}OptionIDs`] = [];
        }
      });
    }
    if (state.projectBookingCustomFields) {
      // setup new custom fields blank values in data state
      state.projectBookingCustomFields.forEach((d) => {
        if (!state.data[this.bcfPRefix(d.name)]) {
          if (!state.data[`${this.bcfPRefix(d.name)}ID`]) {
            state.data[this.bcfPRefix(d.name)] = d.defaultValue;
          }
          if ((d.type === 'dropdown' || d.type === 'dropdown_multi')) {
            state.data[`${this.bcfPRefix(d.name)}OptionID`] = '';
            state.data[`${this.bcfPRefix(d.name)}OptionIDs`] = [];
          }
        }
      });
    }
    // force close booking status modal and editing form
    if (nextProps.refreshPage) {
      state.bookingStatusModal = false;
      state.editingBooking = false;
      state.isUnitChange = false;
    }

    this.setState({ ...state, cancellationReasons });
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  // need to bind this to allow LoanTracker to setLoading
  setLoading = (loading = false) => (new Promise((res) => {
    this.setState({ loading }, res);
  }))
  setBotSyncing = (syncing = false) => (new Promise((res) => {
    this.setState({ isBotSyncing: syncing }, res);
  }))
  setHimsSyncing = (syncing = false) => (new Promise((res) => {
    this.setState({ isHimsSyncing: syncing }, res);
  }))
  getColorText = (status) => {
    switch (status) {
      case 'new':
        return '#3DA0E4';
      case 'pending':
      case 'in_progress':
        return '#969CA4';
      case 'success':
        return '#24A476';
      case 'failed':
        return '#FF796E';
      default:
        return '#566573';
    }
  }
  setLoadingProject = (loadingProject = false) => (new Promise((res) => {
    this.setState({ loadingProject }, res);
  }))
  setLoadingUnit = (loadingUnit = false) => (new Promise((res) => {
    this.setState({ loadingUnit }, res);
  }))
  setMPUserLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ mpUserLoading: loading }, () => {
        res(loading);
      });
    });
  }
  setRefBookingNote = (ref) => {
    this.refBookingNote = ref;
  };
  // CPI-974 (S18): statuses the project blocks until the booking-fee payment is approved.
  getPaymentApprovedRequiredStatusIDs = () => {
    const { oriData } = this.state;
    const project = (oriData && oriData.project) || {};
    return project.paymentApprovedRequiredStatusIDs || [];
  }
  hasApprovedBookingPayment = () => {
    const { data } = this.state;
    const payments = (data && data.bookingFeePayments) || [];
    const relevant = payments.filter(p => p.status !== 'cancelled' && p.status !== 'deduction');
    return relevant.length > 0 && relevant.every(p => p.status === 'paid');
  }
  // CPI-977 (PO, 14 Sep): on a Vietnamese Sales Overview the Payment section is the CRM
  // opportunity's payment screen (VNPayment.jsx), not the Showroom deposit rail; the deposit to
  // collect and the approved-fee rows that used to sit above the rail are gone (PO, 9 Sep).
  // Malaysia keeps BookingPayment untouched.
  showVNPaymentSection = () => isVietnamCompany(this.props.auth)
  isBookingStatusBlockedByPayment = (statusID) => {
    if (!statusID) return false;
    if (!this.getPaymentApprovedRequiredStatusIDs().includes(statusID)) return false;
    return !this.hasApprovedBookingPayment();
  }
  getBlockedBookingStatusLabels = (statusIDs) => {
    const { t } = this.props;
    return statusIDs.map((value) => {
      const status = BOOKING_STATUSES.find(s => s.value === value);
      return status ? t(status.text, { ns: TRANSLATION_FILES.constants }) : value;
    }).join(', ');
  }
  // CPI-976: the project may require the sales form signed before Booked. UX guard only.
  isSignatureRequiredForBooked = () => {
    const { oriData } = this.state;
    const project = (oriData && oriData.project) || {};
    return !!project.signatureRequiredForBooked;
  }
  // Signature evidence: Vietnam is wet-sign only; other countries also accept primary purchaser e-sign.
  hasPurchaserSignatureEvidence = () => {
    const { data } = this.state;
    const { auth } = this.props;
    if (!data) return false;
    if (data.wetSignedAt) return true;
    if (isCountryVietnam(auth && auth.company && auth.company.countryCode)) return false;
    const bookingCustomers = data.bookingCustomers || [];
    // CPI-976 (M3): identify the primary purchaser on bookingCustomerID the way the server's gate
    // does; customerID is not re-synced when the primary is switched, so it is only a fallback.
    let primary = data.bookingCustomerID ?
      bookingCustomers.find(bc => bc.id === data.bookingCustomerID) : null;
    if (!primary) primary = bookingCustomers.find(bc => bc.customerID === data.customerID);
    return !!(primary && primary.signAt);
  }
  isBookingStatusBlockedBySignature = (statusID) => {
    const { oriData } = this.state;
    if (statusID !== 'booked') return false;
    if (oriData && oriData.statusID === 'booked') return false;
    if (!this.isSignatureRequiredForBooked()) return false;
    return !this.hasPurchaserSignatureEvidence();
  }
  getBookingStatuses = () => {
    const auth = this.props.auth;
    const { data } = this.props.appConfig;
    let statuses = BOOKING_STATUSES;
    if (!(isPRS && auth.isSuperAdmin)) {
      statuses = statuses.map((t) => {
        const status = t;
        // disabled expired if is not prs
        if (status.value === 'expired') {
          status.disabled = true;
        }
        return status;
      });
    }
    if (auth && auth.isDeveloperStaff && data && data.settings && !data.settings.allowStaffEditBookingStatusCancel) {
      statuses = statuses.map((t) => {
        const status = t;
        // disabled cancel status
        if (status.value === 'cancelled_developer') {
          status.disabled = true;
        }
        return status;
      });
    }
    // Disabled: no place to enter a payment on a Vietnamese Sales Overview since CPI-974; re-enable when the payment section returns.
    // // CPI-974 item 18: block the project's marked statuses; new objects, the constant is shared.
    // const paymentApprovedRequiredStatusIDs = this.getPaymentApprovedRequiredStatusIDs();
    // if (paymentApprovedRequiredStatusIDs.length > 0 && !this.hasApprovedBookingPayment()) {
    //   statuses = statuses.map(s => (
    //     paymentApprovedRequiredStatusIDs.includes(s.value) ? { ...s, disabled: true } : s
    //   ));
    // }
    // CPI-976: disable Booked while the project requires a purchaser signature and none is on file.
    if (this.isBookingStatusBlockedBySignature('booked')) {
      statuses = statuses.map(s => (s.value === 'booked' ? { ...s, disabled: true } : s));
    }
    return statuses;
  }
  getDataAttributes = (daname, davalue, datarget) => {
    let newDavalue = davalue;
    if (newDavalue === '') newDavalue = 'NULL';
    if (newDavalue === 'Not Applicable') newDavalue = 'N/A';
    const datasetName = `data-bot-${daname}`;
    return {
      [datasetName]: newDavalue,
      'data-bot-target': datarget,
    };
  }
  getDocumentToken(callback) {
    const { store } = this.context;
    store.dispatch(fetchM(`/bookings/${this.state.data.id}/attachments/`, {
      credentials: 'include',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }))
    .catch((err) => {
      store.dispatch(flashErrorMessage(err));
    })
    .then((res) => {
      const documentToken = res.headers.get('X-Csrf-Token');
      this.setState({
        documentToken,
      }, () => {
        if (callback) {
          callback();
        }
      });
    });
  }
  getSelectedStaffValue = () => {
    const { data } = this.state;
    const selectedStaffValue = {
      key: data.assignedMaUserID.toString() || 0,
      title: data.assignedMaName || '',
      price: data.assignedMaPreferredName || '',
    };
    return selectedStaffValue;
  }
  getSelectedCreatorValue = () => {
    const { data } = this.state;
    const SelectedCreatorValue = {
      key: data.maUserID.toString() || 0,
      title: data.maCreatedByPreferredName || '',
      price: '',
    };
    return SelectedCreatorValue;
  }
  getSelectedBank = () => {
    const { data } = this.state;
    let selectedBank = '';
    if (data.selectedBankCaseID && data.selectedBankCaseID !== 0) {
      const idx = data.bankCases.findIndex(bc => bc.id === data.selectedBankCaseID);
      selectedBank = data.bankCases[idx].bank.name;
    } else {
      selectedBank = data.bankName;
    }
    return selectedBank;
  }
  getSuccessBankCase = (data) => {
    if (data.bankCases.length > 0) {
      const soldCase = data.bankCases.find(bankCase => bankCase.status === 'success_li_issued');
      if (soldCase) {
        return soldCase;
      }
    }
    return null;
  }
  canEditConversionDetails = () => {
    const { data } = this.state;
    const { auth } = this.props;
    // Check if the project has the toggle enabled
    if (!data.project || !data.project.allowEditConversionDetailsIsEnabled) {
      return false;
    }
    // Check if user is HQ or Supervisor
    return auth.isHeadquarters || auth.isBranchLeaderSupervisor;
  }
  getPercentageOptions = () => {
    let options = [];
    for (let i = 100; i >= 0; i -= 1) {
      options = [...options, {
        key: i,
        value: i,
        text: `${i}%`,
      }];
    }
    return options;
  }
  handleLoanMarginChange = (e, d) => {
    const { data } = this.state;
    if (d.name === 'loanMargin') {
      const loanMargin = _.toNumber(d.value);
      data.loanAmount = Math.floor((loanMargin / 100) * data.spaValue);
      this.setState({ data }, () => {
        this.handleCheckChanges('bookingChanges');
      });
    }
  }
  handleLoanAmountChange = (e, d) => {
    const { data } = this.state;
    if (d.name === 'loanAmount') {
      let amount = 0;
      if (d.value !== '') {
        amount = parseInt(d.value, 10);
      }
      data.loanAmount = amount;
      this.setState({ data }, () => {
        this.handleCheckChanges('bookingChanges');
      });
    }
  }
  disablePricingEditAfterSold = data => data && data.statusID === 'sold_spa_signed' && data.project && !data.project.allowPricingEditAfterSold
  async resyncBotApi() {
    await this.setBotSyncing(true);
    const { store } = this.context;
    const { t } = this.props;
    let res;
    try {
      res = await store.dispatch(fetchM(`/bookings/${this.state.data.id}/resync_bot/`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
      }));
    } catch (err) {
      await this.setBotSyncing(false);
      const botErrorHeader = 'Re-sync failed';
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ header: botErrorHeader, message: `Bot re-sync failed. ${message}` }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ header: botErrorHeader, message: `${t('An error occurred. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return;
    }
    const botBookingUpdatesData = await res.json();
    const newData = { ...this.state.data };
    newData.botServiceID = botBookingUpdatesData.id;
    newData.botServiceStatus = botBookingUpdatesData.statusID;
    newData.botServiceUpdatedAt = botBookingUpdatesData.updatedAt;
    newData.botServiceErrors = botBookingUpdatesData.errorLogs;
    this.setState({
      data: newData,
      oriData: newData,
    });
    await this.setBotSyncing(false);
    store.dispatch(flashSuccessMessage({ message: 'Bot re-sync successfully triggered' }));
  }
  syncToHimsAPI = async () => {
    await this.setHimsSyncing(true);
    const { store } = this.context;
    const { t } = this.props;
    try {
      await store.dispatch(fetchM(`/bookings/${this.state.data.id}/hims/sync/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
      }));
    } catch (err) {
      await this.setHimsSyncing(false);
      const errorHeader = 'Sync failed';
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ header: errorHeader, message: `HIMS sync failed. ${message}` }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ header: errorHeader, message: `${t('An error occurred. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return;
    }
    await this.setHimsSyncing(false);
    store.dispatch(replace(`/bookings/${this.state.data.id}/`));
    store.dispatch(flashSuccessMessage({ message: 'HIMS sync successfully triggered' }));
  }
  resyncHimsAPI = async () => {
    await this.setHimsSyncing(true);
    const { store } = this.context;
    const { t } = this.props;
    let res;
    try {
      res = await store.dispatch(fetchM(`/bookings/${this.state.data.id}/hims/sync/retry/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
      }));
    } catch (err) {
      await this.setHimsSyncing(false);
      const errorHeader = 'Re-sync failed';
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ header: errorHeader, message: `HIMS re-sync failed. ${message}` }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ header: errorHeader, message: `${t('An error occurred. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return;
    }
    await this.setHimsSyncing(false);
    store.dispatch(replace(`/bookings/${this.state.data.id}/`));

    const newBookingData = await res.json();
    if (newBookingData.himsServiceErrors && newBookingData.himsServiceErrors.length > 0) {
      store.dispatch(flashErrorMessage({ header: 'Sync failed', message: 'HIMS sync failed. Please check the error logs.' }));
      return;
    }
    store.dispatch(flashSuccessMessage({ message: 'HIMS re-sync successfully triggered' }));
  }
  getTierPricingValue = () => {
    const { data } = this.state;
    const priceTierData = this.optionsTierPricings().find(d => d.description === data.nettSellingPrice.toString());
    if (priceTierData) return priceTierData.value;
    return data.spaAmount;
  }
  setPricePerSqm = (b) => {
    const data = b;
    if (data.systemPricePerSqm === 0) {
      data.systemPricePerSqm = calculatePricePerSqm(data.spaAmount, data.project, data.projectUnit);
    }
    // if same with system, reset to 0
    if (data.pricePerSqm === data.systemPricePerSqm) {
      data.pricePerSqm = 0;
    }
    // reset system to 0
    data.systemPricePerSqm = 0;
    data.pricePerSqm = parseFloat(data.pricePerSqm);
    return data;
  }
  async resendFRHBooking(xid = this.state.data.id) {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    try {
      await store.dispatch(fetchM(`/bookings/${xid}/frh_resend/`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return;
    }
    await this.setLoading(false);
    store.dispatch(flashSuccessMessage({ header: t('Resend Success', { ns: TRANSLATION_FILES.translation }) }));
  }
  async resendJDEBooking(xid = this.state.data.id) {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    try {
      await store.dispatch(fetchM(`/bookings/${xid}/jde_resend/`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return;
    }
    await this.setLoading(false);
    store.dispatch(flashSuccessMessage({ header: t('Resend Success', { ns: TRANSLATION_FILES.translation }) }));
  }
  async resendBooking(xid = this.state.data.id) {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    try {
      await store.dispatch(fetchM(`/bookings/${xid}/es_resend/`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return;
    }
    await this.setLoading(false);
    store.dispatch(flashSuccessMessage({ header: t('Resend Success', { ns: TRANSLATION_FILES.translation }) }));
  }
  async deleteAttachment(fileID) {
    const { store } = this.context;
    const { data } = this.state;
    const { t } = this.props;
    await this.setLoading(true);
    try {
      await store.dispatch(fetchM(`/bookings/${data.id}/attachments/${fileID}/`, {
        credentials: 'include',
        method: 'DELETE',
        headers: {
          'X-Csrf-Token': this.state.documentToken,
        },
      }));
    } catch (err) {
      await this.setLoading(false);
      Bugsnag.notifyException(err);
      if (err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
    }
    await this.props.fetchNewBooking();
    await this.setLoading(false);
    store.dispatch(flashSuccessMessage({
      header: t('Delete Success', { ns: TRANSLATION_FILES.translation }),
      message: t('Attachment(s) successfully deleted', { ns: TRANSLATION_FILES.translation }),
    }));
  }
  async updateBooking(booking, type = 'update', xid = this.state.data.id) {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    const b = booking;
    if (type === 'update') {
      // read the custom field refs from CustomFieldForm directly — the
      // onChange-passed copy is empty until the user edits a custom field,
      // which let required fields through untouched
      const customFieldValidation = (this.customFieldFormRef.current && this.customFieldFormRef.current.validation) || this.customFieldValidation;
      const validations = await AppForm.validate({ ...this.validation, ...customFieldValidation }, this.state.data);
      const errMessages = validations.filter(v => !v.isValid);
      await this.setComponentState({
        errMessages,
      });
      if (errMessages.length > 0) {
        await this.setLoading(false);
        store.dispatch(flashErrorMessage({ header: t('Please fix form errors', { ns: TRANSLATION_FILES.translation }), list: errMessages.map(l => l.message) }));
        return;
      }
    }
    if (b.statusID === 'reserved' || b.statusID === 'booked') {
      b.isCancelPending = false;
      b.isUserCooldown = false;
    }
    let res = '';
    try {
      res = await store.dispatch(fetchM(`/bookings/${xid}/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify(b),
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return;
    }
    const data = await res.json();
    if (
        data.statusID === 'booked' &&
        data.project &&
        data.project.autoShareFormToBanker &&
        data.bankCases &&
        data.bankCases.length > 0 &&
        data.pdfLastSentAt === null
      ) {
      try {
        await store.dispatch(fetchM(`/bookings/${xid}/print_banker/`, {
          credentials: 'include',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Csrf-Token': this.props.token,
          },
        }));
      } catch (err) {
        Bugsnag.notifyException(err);
      }
    }
    await this.setLoading(false);
    await this.setComponentState({
      editingPayment: type === 'payment' ? false : this.state.editingPayment,
      editingBooking: type !== 'payment' ? false : this.state.editingBooking,
    });
    if (type === 'primary') {
      store.dispatch(replace(`/bookings/${this.state.data.id}/`));
      store.dispatch(flashSuccessMessage({
        header: t('Update Success', { ns: TRANSLATION_FILES.translation }),
        message: t('Primary purchaser has been successfully updated.', { ns: TRANSLATION_FILES.translation }),
      }));
    } else {
      this.handleResetCheck(type === 'payment' ? 'paymentChanges' : 'bookingChanges');
      store.dispatch(push(`/bookings/${xid}/`));
      store.dispatch(flashSuccessMessage({
        header: t('Update Success', { ns: TRANSLATION_FILES.translation }),
        message: t('Booking {{code}} successfully updated', { code: data.code, ns: TRANSLATION_FILES.translation }),
      }));
      this.callRefreshBookingNote();
    }
  }
  async updateBookingPP(selectedPackagePricingItem) {
    await this.setLoading(true);
    const { store } = this.context;
    const { oriData } = this.state;
    const { t } = this.props;
    const newData = Object.assign({}, oriData || {});
    let res = '';
    try {
      res = await store.dispatch(fetchM(`/bookings/${oriData.id}/package_pricing/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify(selectedPackagePricingItem),
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return;
    }
    const json = await res.json();
    newData.packagePricing = json.packagePricing;
    newData.packagePricingID = json.packagePricingID;
    newData.spaDecimal = json.spaDecimal;
    newData.spaValue = json.spaValue;
    newData.spaTimes = json.spaTimes;
    newData.spaFull = json.spaFull;
    newData.spaAmount = spaFullNumber(newData) || newData.spaValue;
    this.setState({
      data: newData,
      oriData: newData,
    });
    await this.setLoading(false);
    store.dispatch(replace(`/bookings/${this.state.data.id}/`));
    await store.dispatch(flashSuccessMessage({
      header: t('Pricing Package'),
      message: t('Pricing package successfully updated', { ns: TRANSLATION_FILES.translation }),
    }));
  }
  async updateBookingPPFormulas(calcs) {
    await this.setLoading(true);
    const { store } = this.context;
    const { oriData } = this.state;
    const { t } = this.props;
    const newData = Object.assign({}, oriData || {});
    let res = '';
    const newCalcs = calcs.map(c => ({
      ...c,
      formulaValue: c.formulaValue.toString(),
    }));
    try {
      res = await store.dispatch(fetchM(`/bookings/${oriData.id}/formulas/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify(newCalcs),
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return;
    }
    const json = await res.json();
    newData.packagePricing.calculations = json.packagePricing.calculations;
    newData.spaDecimal = json.spaDecimal;
    newData.spaValue = json.spaValue;
    newData.spaTimes = json.spaTimes;
    newData.spaFull = json.spaFull;
    newData.spaAmount = spaFullNumber(newData) || newData.spaValue;
    this.setState({
      data: newData,
      oriData: newData,
    });
    await this.setLoading(false);
    store.dispatch(replace(`/bookings/${this.state.data.id}/`));
    await store.dispatch(flashSuccessMessage({
      header: t('Pricing Package'),
      message: t('Pricing package successfully updated', { ns: TRANSLATION_FILES.translation }),
    }));
  }
  async updateBookingFP(selectedFeePackage) {
    await this.setLoading(true);
    const { store } = this.context;
    const { oriData } = this.state;
    const newData = Object.assign({}, oriData || {});
    let res = '';
    try {
      res = await store.dispatch(fetchM(`/bookings/${oriData.id}/fee_packages/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify(selectedFeePackage),
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: 'There was an error with your request. Please try again.' }));
      return;
    }
    const json = await res.json();
    newData.packageFee = json.packageFee;
    newData.packageFeeID = json.packageFeeID;
    this.setState({
      data: newData,
      oriData: newData,
    });
    await this.setLoading(false);
    store.dispatch(replace(`/bookings/${this.state.data.id}/`));
    await store.dispatch(flashSuccessMessage({ header: 'Additonal Fee Package', message: 'Additonal fee package successfully updated' }));
  }
  async updateBookingFPFormulas(calcs) {
    await this.setLoading(true);
    const { store } = this.context;
    const { oriData } = this.state;
    const newData = Object.assign({}, oriData || {});
    let res = '';
    try {
      res = await store.dispatch(fetchM(`/bookings/${oriData.id}/fee_packages/formulas/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify(calcs),
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: 'There was an error with your request. Please try again.' }));
      return;
    }
    const json = await res.json();
    newData.packageFee.items = json.packageFee.items;
    this.setState({
      data: newData,
      oriData: newData,
    });
    await this.setLoading(false);
    store.dispatch(replace(`/bookings/${this.state.data.id}/`));
    await store.dispatch(flashSuccessMessage({ header: 'Additional Fee Package', message: 'Additional fee package successfully updated' }));
  }
  async updateSalesPersonSignature(salesPersonSignature) {
    await this.setLoading(true);
    const { store } = this.context;
    const { oriData } = this.state;
    const { t } = this.props;
    let newData = Object.assign({}, oriData || {});
    newData.salesPersonSignature = salesPersonSignature;
    newData.isCancelPending = false;
    newData.isUserCooldown = false;
    newData = this.setPricePerSqm(newData);
    let res = '';
    try {
      res = await store.dispatch(fetchM(`/bookings/${oriData.id}/signature/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify(newData),
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return;
    }
    const json = await res.json();
    newData.salesPersonSignAt = json.salesPersonSignAt;
    this.setState({
      showSignModal: false,
      isSalesPersonSignature: false,
      data: newData,
    });
    await this.setLoading(false);
    await this.signatureModal.handleOnCancel();
    await store.dispatch(flashSuccessMessage({
      header: t('Sign Success', { ns: TRANSLATION_FILES.translation }),
      message: t('Sales Person {{name}} has signed', { name: oriData.maCreatedByPreferredName, ns: TRANSLATION_FILES.translation }),
    }));
  }
  async uploadAttachments(body) {
    const { data } = this.state;
    const { store } = this.context;
    const { t } = this.props;
    await this.setLoading(true);
    try {
      await store.dispatch(fetchM(`/bookings/${data.id}/attachments/`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'X-Csrf-Token': this.state.documentToken,
        },
        body,
      }));
    } catch (err) {
      await this.setLoading(false);
      Bugsnag.notifyException(err);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return;
    }
    await this.props.fetchNewBooking();
    await this.setLoading(false);
    this.setState({ uploadModalState: false });
    this.bookingAttachment.uploadModal.close();
    store.dispatch(flashSuccessMessage({
      header: t('Upload Success', { ns: TRANSLATION_FILES.translation }),
      message: t('Attachment(s) successfully uploaded', { ns: TRANSLATION_FILES.translation }),
    }));
  }
  async submitNoetic(xid = this.state.data.id) {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    try {
      await store.dispatch(fetchM(`/bookings/${xid}/noetic/`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return;
    }
    await this.setLoading(false);
    store.dispatch(replace(`/bookings/${this.state.data.id}/`));
    store.dispatch(flashSuccessMessage({
      header: t('Success', { ns: TRANSLATION_FILES.constants }),
      message: t('Booking has been added to the {{name}} synchronizing queue', { name: 'noetic', ns: TRANSLATION_FILES.translation }),
    }));
  }
  async submitIFCA(xid = this.state.data.id) {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    try {
      await store.dispatch(fetchM(`/bookings/${xid}/ifca/`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return;
    }
    await this.setLoading(false);
    store.dispatch(replace(`/bookings/${this.state.data.id}/`));
    store.dispatch(flashSuccessMessage({
      header: t('Success', { ns: TRANSLATION_FILES.constants }),
      message: t('Booking has been added to the {{name}} synchronizing queue', { name: 'IFCA', ns: TRANSLATION_FILES.translation }),
    }));
  }
  async submitInsoft(xid = this.state.data.id) {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    try {
      await store.dispatch(fetchM(`/bookings/${xid}/insoft/`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return;
    }
    await this.setLoading(false);
    store.dispatch(replace(`/bookings/${this.state.data.id}/`));
    store.dispatch(flashSuccessMessage({
      header: t('Success', { ns: TRANSLATION_FILES.constants }),
      message: t('Booking has been added to the {{name}} synchronizing queue', { name: 'Insoft', ns: TRANSLATION_FILES.translation }),
    }));
  }
  async fetchProjects() {
    const { t } = this.props;
    const { store } = this.context;
    await this.setLoadingProject(true);
    const query = {
      limit: 0,
      showAsOptions: true,
      fromChangeUnit: true,
      projectStatus: ['published'],
    };
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      if (err.res && err.res.status >= 399 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      await this.setLoadingProject(false);
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const data = await res.json();
      let { projectOpts } = this.state;
      if (data && data.length > 0) {
        projectOpts = data.map(d => ({ value: d.id, text: d.name }));
      }

      await this.setComponentState({ projectOpts });
    }
    await this.setLoadingProject(false);
  }
  async fetchUnits() {
    if (!this.state.changeProjectID) {
      return;
    }
    const { t } = this.props;
    const { oriData } = this.state;
    const { store } = this.context;
    await this.setLoadingUnit(true);
    const query = {
      limit: 0,
      showAsOptions: true,
      unitStatus: 'new',
      showDelist: this.checkAllowChangeUnit() && oriData.project.cuDelistOnHoldIsEnabled,
    };
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/${this.state.changeProjectID}/units/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      if (err.res && err.res.status >= 399 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      await this.setLoadingUnit(false);
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const data = await res.json();
      let { unitOpts } = this.state;
      if (data && data.length > 0) {
        unitOpts = data.map(d => ({ value: d.id, text: `${d.reference} ${d.statusID === 'delist' ? `- ${t('delisted')}` : ''} ${d.statusID === 'delist' && d.delistOnHold ? t('(on hold)') : ''}` }));
      }

      await this.setComponentState({ unitOpts });
    }
    await this.setLoadingUnit(false);
  }
  async fetchJDELogs() {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    let res;
    try {
      res = await store.dispatch(fetchM(`/bookings/${this.state.data.id}/jde_logs/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return;
    }
    if (!res.ok) {
      await this.setLoading(false);
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const data = await res.json();
      await this.setComponentState({
        validationSvcErrorModalContent: data,
      });
      await this.setLoading(false);
    }
  }
  handleUploadSecureDocuments = async (bookingID, uploadFiles, uploadCount) => {
    if (!uploadFiles || !uploadCount || uploadCount < 1) {
      return {
        total: 0,
        uploaded: 0,
        failed: 0,
      };
    }

    const documentType = 'other_documents';
    const uploadPath = `showroom/bookings/${bookingID}`;
    const files = [];
    let missingFilesCount = 0;

    for (let i = 0; i < uploadCount; i += 1) {
      const file = uploadFiles.get(`files_${i}`);
      if (file && file.name) {
        files.push(file);
      } else {
        missingFilesCount += 1;
      }
    }

    const uploadSingleFile = file => sdsClient.uploadDocument({
      path: utilities.buildFolderDocumentPath(uploadPath, file.name),
      content: file,
      documentType,
    });

    // First attempt
    const firstAttempt = await Promise.allSettled(files.map(file => uploadSingleFile(file)));
    const retryFiles = files.filter((file, index) => firstAttempt[index].status === 'rejected' && file);

    // Retry failed uploads once for transient network/storage failures
    const secondAttempt = await Promise.allSettled(retryFiles.map(file => uploadSingleFile(file)));
    const secondAttemptFailedCount = secondAttempt.filter(res => res.status === 'rejected').length;

    const total = uploadCount;
    const failed = missingFilesCount + secondAttemptFailedCount;
    const uploaded = Math.max(total - failed, 0);

    return {
      total,
      uploaded,
      failed,
    };
  }
  async submitChangeUnit(value) {
    const { attachmentsUploaded, attachmentsUploadedCount } = value;
    const { changeProjectID, changeUnitID, oriData } = this.state;
    if (!changeProjectID || !changeUnitID) {
      return;
    }

    // Store pending change unit data without calling API yet
    const pendingChangeUnitData = {
      projectID: changeProjectID,
      projectUnitID: changeUnitID,
      cuFollowPrevBookingDateIsEnabled: oriData.project.cuFollowPrevBookingDateIsEnabled && oriData.cuFollowPrevBookingDateIsEnabled,
      attachmentsUploaded,
      attachmentsUploadedCount,
    };

    // Show cancellation modal immediately
    const { data } = this.state;
    data.statusID = 'cancelled_developer';
    await this.setComponentState({
      data,
      editingBooking: false,
      bookingStatusModal: true,
      isUnitChange: true,
      pendingChangeUnitData,
    });
  }
  callRefreshBookingNote = () => {
    if (this.refBookingNote) {
      this.refBookingNote.handleForceRefresh(true);
    }
  }
  fetchMarketplaceUserDetails = async (userID) => {
    const { store } = this.context;
    const { t } = this.props;
    const url = `/marketplace/staffs/${userID}/`;
    try {
      await this.setMPUserLoading(true);
      const response = await serverRequestGet(
        url,
        store,
      );
      if (response.error) {
        await store.dispatch(flashErrorMessage({ message: response.message }));
        return;
      }
      await this.setState({ mpUserDetails: response.data });
      await this.setMPUserLoading(false);
    } catch (e) {
      Bugsnag.notifyException(e);
      await this.setMPUserLoading(false);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
    }
  }

  toggleActiveStates = (name, s) => this.setState(prev => ({ [name]: s !== undefined ? s : !prev[name] }));

  bcfPRefix = v => `bcf_${v}`

  isCustomFieldRequiredAtStatus = (field, statusID) => {
    // Only applies to booking custom fields
    if (!field.isRequired) {
      return false;
    }

    // For DEFAULT fields (purchaser fields), always use isRequired directly
    // Status-based logic only applies to custom booking fields
    if (field.isDefault) {
      return field.isRequired;
    }

    const currentStatus = statusID || 'reserved';
    const requiredAtStatus = field.requiredAtStatus || 'reserved';

    // Define status hierarchy: reserved < booked < sold_spa_signed
    const statusHierarchy = {
      'reserved': 1,
      'booked': 2,
      'sold_spa_signed': 3,
    };

    const currentLevel = statusHierarchy[currentStatus];
    const requiredLevel = statusHierarchy[requiredAtStatus];

    if (!currentLevel || !requiredLevel) {
      return false;
    }

    return currentLevel >= requiredLevel;
  }

  hasMPDetailsAccess = () => {
    const { auth } = this.props;
    return auth.isHeadquarters || auth.isBranchLeaderSupervisor;
  }
  hasAccess(check = false, admin = true, dhq = true, dbl = true, internal = false) {
    const auth = this.props.auth;
    if (dbl && this.props.auth.isBranchLeader) {
      return true;
    }
    if (dhq && this.props.auth.isHeadquarters) {
      return true;
    }
    if (admin && this.props.auth.isSuperAdmin) {
      return true;
    }
    if (internal && auth && auth.companyBranch && !auth.companyBranch.isExternal) {
      return true;
    }
    return check;
  }
  hasAccessChangeUnit = () => {
    const { auth } = this.props;
    const { oriData } = this.state;
    const cuRoleAccesses = oriData && oriData.project && oriData.project.cuRoleAccesses ? oriData.project.cuRoleAccesses : [];
    if (auth.isAdmin || auth.isHeadquarters || auth.isBranchLeader) return true;
    if (cuRoleAccesses.includes(CU_STAFF_ACCESS) && auth.isDeveloperStaff) return true;
    if (cuRoleAccesses.includes(CU_EXTERNAL_STAFF_ACCESS) && auth.isDeveloper && auth.companyBranch && auth.companyBranch.isExternal) {
      if (oriData.project.cuAllowExternalReserved && oriData.statusID === 'reserved') {
        return true;
      }
      if (oriData.project.cuAllowExternalBooked && oriData.statusID === 'booked') {
        return true;
      }
    }
    return false;
  }
  hasAccessNettSellingPrice(project) {
    const auth = this.props.auth;
    if (this.props.auth.isSuperAdmin || this.props.auth.isHeadquarters) {
      return true;
    }
    if (project && project.accessBULNettSellingPrice && this.props.auth.isBranchLeader) {
      return true;
    }
    if (project && project.accessStaffNettSellingPrice && auth && auth.companyBranch) {
      return true;
    }
    return false;
  }
  // CPI-1212: Source of Finance is read-only for a base external agent unless the project allows
  // it. Vietnam only; the rule itself is canEditSourceOfFinance in src/utils/vietnam.js.
  hasAccessSourceOfFinance = () => {
    const { auth } = this.props;
    const { data } = this.state;
    if (!isVietnamCompany(auth)) return true;
    if (this.hasAccess(false, true, true, true, true)) return true;
    return canEditSourceOfFinance(auth, data && data.project);
  }
  showAgentCuButton(statusID) {
    const auth = this.props.auth;
    const { data } = this.state;
    if (vnChangeUnitBlocked(auth, data)) return false;
    // Pre-Sales Launch: change unit creates a new booking, so a role blocked from reserving is blocked here too.
    if (reservationBlocked(auth, data && data.project)) return false;
    if (auth.companyBranch.isExternal) {
      if (data.project.cuAllowExternalReserved && statusID === 'reserved' && !data.project.allowAgentManageBooking) {
        return true;
      }
      if (data.project.cuAllowExternalBooked && statusID === 'booked') {
        return true;
      }
    }
    return false;
  }
  hasEditBookingAccess(maUserID, statusID) {
    const auth = this.props.auth;
    const { data } = this.state;
    if (data.project.allowAgentManageBooking &&
      auth.companyBranch.isExternal &&
      statusID === 'reserved'
    ) {
      if (auth.isExternalAgentLeader) {
        return true;
      } else if (maUserID === auth.id) {
        return true;
      }
    }
    return false;
  }
  hasBookingNoteReadAccess(project) {
    const user = this.props.auth;
    if (user.isAdminBasic || user.isAdmin) return true;
    if (project && project.bnReadAccessGroupIDs) {
      const uGroupIDs = [...user.groups.map(obj => obj.id)];
      const uSrRoleIDs = matchGroupIDToSrRoleID(uGroupIDs, user.companyBranch.isExternal);
      return hasAnyRequiredRoleIDs(project.bnReadAccessGroupIDs, uSrRoleIDs);
    }
    return false;
  }
  hasBookingNoteWriteAccess(project) {
    const user = this.props.auth;
    if (user.isAdminBasic || user.isAdmin) return true;
    if (project && project.bnWriteAccessGroupIDs) {
      const uGroupIDs = [...user.groups.map(obj => obj.id)];
      const uSrRoleIDs = matchGroupIDToSrRoleID(uGroupIDs, user.companyBranch.isExternal);
      return hasAnyRequiredRoleIDs(project.bnWriteAccessGroupIDs, uSrRoleIDs);
    }
    return false;
  }
  handleOnCheck = (callback) => {
    if (this.props.onCheck) {
      const hasChanges = (
        this.state.bookingChanges ||
        this.state.paymentChanges ||
        this.state.isBookingPaymentChanged ||
        this.state.isBookingFeePaymentChanged
      );
      this.props.onCheck(hasChanges, callback);
    }
  }
  handleCheckChanges = (value, callback) => {
    const state = this.state;
    if (state[value] === false) {
      state[value] = true;
      this.setState({ [value]: state[value] }, () => {
        this.handleOnCheck(callback);
      });
    }
  }
  handleResetCheck = (value, callback) => {
    const state = this.state;
    if (state[value] === true) {
      state[value] = false;
      this.setState({ [value]: state[value] }, () => {
        this.handleOnCheck(callback);
      });
    }
  }
  handleResetPricePerSqm = () => {
    const { data } = this.state;
    if (data.systemPricePerSqm > 0) {
      data.pricePerSqm = data.systemPricePerSqm;
    } else {
      data.pricePerSqm = calculatePricePerSqm(data.spaAmount, data.project, data.projectUnit);
    }
    this.setState({ data }, () => {
      this.handleCheckChanges('bookingChanges');
    });
  }
  handleBookingChange = (event, value) => {
    const { data } = this.state;
    data[value.name] = value.value;
    this.setState({ data }, () => {
      this.handleCheckChanges('bookingChanges');
    });
  }
  handleTierPricingChange = (e, v) => {
    const { data, unitTiers } = this.state;
    const priceTier = this.optionsTierPricings().find(d => d.value === v.value);
    if (priceTier) {
      data.spaAmount = amountToFixed(parseFloat(priceTier.description), data.projectUnit.spaTimes);
      data.nettSellingPrice = priceTier.description;
      if (unitTiers) {
        const priceTierData = unitTiers.find(d => d.projectPricingID === priceTier.value);
        if (priceTierData && priceTierData.projectPricing) {
          data.tierPricingName = priceTierData.projectPricing.name;
          data.tierPricingDescription = priceTierData.projectPricing.description;
        } else {
          data.tierPricingName = 'Base';
          data.tierPricingDescription = `Base Selling Price: ${v.value}`;
        }
      }
    }
    this.setState({ data }, () => {
      this.handleCheckChanges('bookingChanges');
    });
  }
  handleBookingSpecificationChange = (specifications) => {
    const { data } = this.state;
    data.specifications = specifications;
    this.setState({ data }, () => {
      this.handleCheckChanges('bookingChanges');
    });
  }
  handleBookingAmountChange = (event, value) => {
    if (isNumeric(value.value) || value.value === '') {
      const { data } = this.state;
      data[value.name] = value.value;
      this.setState({ data }, () => {
        this.handleCheckChanges('bookingChanges');
      });
    }
  }
  handleUpdateBooking = () => {
    const { data, oriData, projectBookingCustomFields } = this.state;
    this.setState({
      approvedDatePickerVisible: false,
      cancelledDatePickerVisible: false,
      soldDatePickVisible: false,
      spaSigningDatePickerVisible: false,
      spaStampingDatePickerVisible: false,
    });
    if (data.maUserID === 0) {
      data.maCreatedByName = oriData.maCreatedByName;
      data.maCreatedByEmail = oriData.maCreatedByEmail;
      data.maCreatedByPreferredName = oriData.maCreatedByPreferredName;
      data.maUserAffiliateCompanyBranchShortName = oriData.maUserAffiliateCompanyBranchShortName;
      data.maUserAffiliateCompanyBranchID = oriData.maUserAffiliateCompanyBranchID;
      data.maUserAffiliateCompanyID = oriData.maUserAffiliateCompanyID;
      data.maUserAffiliateID = oriData.maUserAffiliateID;
      data.maUserID = oriData.maUserID;
      this.setState({ data });
    }
    const bookingCustomFields = [];
    if (data.bookingCustomFields) {
      data.bookingCustomFields.forEach((d) => {
        const customField = {
          id: d.id,
          value: data[this.bcfPRefix(d.projectBookingCustomField.name)],
          projectBookingCustomFieldID: d.projectBookingCustomFieldID,
          projectBookingCustomFieldOptionID: data[`${this.bcfPRefix(d.projectBookingCustomField.name)}OptionID`],
          projectBookingCustomFieldOptionIDs: data[`${this.bcfPRefix(d.projectBookingCustomField.name)}OptionIDs`],
        };
        bookingCustomFields.push(customField);
      });
    }
    if (projectBookingCustomFields) {
      projectBookingCustomFields.filter(bcf => DEFAULT_BOOKING_FIELD_LIST.every(pf => bcf.name !== pf.name)).forEach((d) => {
        let exists = -1;
        if (data.bookingCustomFields) exists = data.bookingCustomFields.findIndex(bcfData => bcfData.projectBookingCustomField.id === d.id);
        if (exists === -1) {
          const customField = {
            value: data[this.bcfPRefix(d.name)],
            projectBookingCustomFieldID: d.id,
            projectBookingCustomFieldOptionID: data[`${this.bcfPRefix(d.name)}OptionID`],
            projectBookingCustomFieldOptionIDs: data[`${this.bcfPRefix(d.name)}OptionIDs`],
          };
          bookingCustomFields.push(customField);
        }
      });
    }
    const newData = this.setPricePerSqm(data);
    let booking = {
      bookingCustomFields,
      paymentMethodID: data.paymentMethodID,
      spaValue: parseInt(data.spaAmount, 10),
      nettSellingPrice: parseFloat(data.nettSellingPrice),
      newBookingNoteEncoded: data.newBookingNoteEncoded,
      remarkInternal: data.remarkInternal,
      assignedMaName: data.assignedMaName,
      assignedMaPreferredName: data.assignedMaPreferredName,
      assignedMaUserID: data.assignedMaUserID,
      tierPricingName: data.tierPricingName,
      tierPricingDescription: data.tierPricingDescription,
      maCreatedByName: data.maCreatedByName,
      maCreatedByEmail: data.maCreatedByEmail,
      maCreatedByPreferredName: data.maCreatedByPreferredName,
      maUserAffiliateCompanyBranchShortName: data.maUserAffiliateCompanyBranchShortName,
      maUserAffiliateCompanyBranchID: data.maUserAffiliateCompanyBranchID,
      maUserAffiliateCompanyID: data.maUserAffiliateCompanyID,
      maUserAffiliateID: data.maUserAffiliateID,
      maUserID: data.maUserID,
      specifications: data.specifications,
      forceRecalculatePackagePricing: data.forceRecalculatePackagePricing,
      srpLoan: data.srpLoan,
      firstTimeBuyer: data.firstTimeBuyer,
      approvedAt: data.approvedAt,
      cancelledAt: data.cancelledAt,
      lastSoldAt: data.lastSoldAt,
      spaSigningDate: data.spaSigningDate,
      spaStampingDate: data.spaStampingDate,
      cancellationReasonID: data.cancellationReasonID,
      pricePerSqm: newData.pricePerSqm,
      updatedAt: data.updatedAt,
      bankName: data.bankName,
      bankerName: data.bankerName,
      loanAmount: parseInt(data.loanAmount, 10) || 0,
    };
    booking = fullToAmount(booking, data.spaAmount); // decimal amount
    if (
      booking.paymentMethodID !== oriData.paymentMethodID ||
      booking.spaAmount !== oriData.spaAmount ||
      booking.tierPricingName !== oriData.tierPricingName ||
      booking.tierPricingDescription !== oriData.tierPricingDescription ||
      booking.nettSellingPrice !== oriData.nettSellingPrice ||
      booking.remarkInternal !== oriData.remarkInternal ||
      booking.assignedMaName !== oriData.assignedMaName ||
      booking.assignedMaPreferredName !== oriData.assignedMaPreferredName ||
      booking.assignedMaUserID !== oriData.assignedMaUserID ||
      booking.maCreatedByPreferredName !== oriData.maCreatedByPreferredName ||
      booking.maUserAffiliateCompanyBranchShortName !== oriData.maUserAffiliateCompanyBranchShortName ||
      booking.maUserAffiliateCompanyBranchID !== oriData.maUserAffiliateCompanyBranchID ||
      booking.maUserAffiliateCompanyID !== oriData.maUserAffiliateCompanyID ||
      booking.maUserAffiliateID !== oriData.maUserAffiliateID ||
      booking.maUserID !== oriData.maUserID ||
      booking.bankName !== oriData.bankName ||
      booking.bankerName !== oriData.bankerName ||
      booking.loanAmount !== oriData.loanAmount ||
      booking.approvedAt !== oriData.approvedAt ||
      booking.cancelledAt !== oriData.cancelledAt ||
      booking.lastSoldAt !== oriData.lastSoldAt ||
      booking.spaSigningDate !== oriData.spaSigningDate ||
      booking.spaStampingDate !== oriData.spaStampingDate ||
      booking.cancellationReasonID !== oriData.cancellationReasonID ||
      !this.checkJSONStringifyMatch(booking.specifications, oriData.specifications) ||
      this.checkCustomFieldsChanged(data.bookingCustomFields, projectBookingCustomFields, data)
    ) {
      this.updateBooking(booking, 'update');
    } else {
      this.setState({ editingBooking: false });
    }
  }
  handleEditBooking = () => {
    this.setState({ editingBooking: true, showCustomFields: true });
  }
  handleResetBooking = () => {
    const { data, oriData } = this.state;
    const editingBooking = false;
    const showChangeUnit = false;
    data.spaAmount = oriData.spaAmount;
    data.spaValue = oriData.spaValue;
    data.spaDecimal = oriData.spaDecimal;
    data.spaFull = oriData.spaFull;
    data.spaTimes = oriData.spaTimes;
    data.nettSellingPrice = parseInt(oriData.nettSellingPrice, 10);
    data.paymentMethodID = oriData.paymentMethodID;
    data.statusID = oriData.statusID;
    data.cancellationReasonID = oriData.cancellationReasonID;
    data.pricePerSqm = oriData.pricePerSqm;
    data.approvedAt = oriData.approvedAt;
    data.cancelledAt = oriData.cancelledAt;
    data.lastSoldAt = oriData.lastSoldAt;
    data.spaSigningDate = oriData.spaSigningDate;
    data.spaStampingDate = oriData.spaStampingDate;
    data.bankName = oriData.bankName;
    data.bankerName = oriData.bankerName;
    data.loanAmount = oriData.loanAmount;
    this.setState({ data, editingBooking, showChangeUnit }, () => {
      this.handleResetCheck('bookingChanges');
    });
  }
  handleUpdatePayment = (payment) => {
    this.updateBooking(payment, 'payment');
  }
  handleSalesSign = (e) => {
    e.preventDefault();
    this.setState({ isSalesPersonSignature: true, showSignModal: true });
  }
  handleOnCancel = (e) => {
    e.preventDefault();
    this.signatureModal.handleOnCancel();
    this.setState({
      isSalesPersonSignature: false,
      showSignModal: false,
    });
  }
  isBookingStatusDisabled = (bookingData = {}) => {
    const { statusID, project } = bookingData;
    const auth = this.props.auth;
    const { data } = this.props.appConfig;
    return (!auth.isSuperAdmin && statusID === 'expired') ||
    (data.creditControlIsEnabled && !project.creditControlIsUnlinked && statusID === 'sold_spa_signed');
  }
  isBookingStatusUpdateBlocked = (bookingData = {}) => {
    const { statusID, project } = bookingData;
    const { data } = this.props.appConfig;
    return (data.creditControlIsEnabled && !project.creditControlIsUnlinked && statusID === 'sold_spa_signed');
  }
  saveSignature = async (event) => {
    event.preventDefault();
    const { store } = this.context;
    const { t } = this.props;
    if (this.signatureModal.isEmpty()) {
      store.dispatch(flashErrorMessage({ header: t('Error', { ns: TRANSLATION_FILES.translation }), message: t('Please sign the consent', { ns: TRANSLATION_FILES.translation }) }));
      return;
    }
    const salesPersonSignature = this.signatureModal.signData().replace(/^data:image\/(png|jpg);base64,/, '');
    this.updateSalesPersonSignature(salesPersonSignature);
  }
  handleStaffClear = () => {
    const { data } = this.state;
    data.assignedMaName = '';
    data.assignedMaPreferredName = '';
    data.assignedMaUserID = 0;
    this.setState({ data }, () => {
      this.handleCheckChanges('bookingChanges');
    });
  }
  handleStaffSelect = (value) => {
    const { data } = this.state;
    data.assignedMaName = value.title;
    data.assignedMaPreferredName = value.price;
    data.assignedMaUserID = value.key;
    this.setState({ data }, () => {
      this.handleCheckChanges('bookingChanges');
    });
  }
  handleUserClear = () => {
    const { data } = this.state;
    data.maCreatedByPreferredName = '';
    data.maCreatedByName = '';
    data.maCreatedByEmail = '';
    data.maUserID = 0;
    data.maUserAffiliateCompanyBranchShortName = '';
    data.maUserAffiliateCompanyBranchID = 0;
    data.maUserAffiliateCompanyID = 0;
    data.maUserAffiliateID = 0;
    this.setState({ data, searchUserValue: '' }, () => {
      this.handleCheckChanges('bookingChanges');
    });
  }
  handleUserSelect = (value) => {
    const { data, searchUsersData } = this.state;
    const selectedUser = searchUsersData.find(d => d.email === value.description);
    if (selectedUser &&
      selectedUser.name !== '' &&
      selectedUser.preferredName !== '' &&
      selectedUser.companyBranchShortName !== '' &&
      selectedUser.companyBranchID > 0 &&
      selectedUser.companyID > 0 &&
      selectedUser.affiliateID > 0 &&
      selectedUser.id > 0) {
      data.maCreatedByName = selectedUser.name;
      data.maCreatedByEmail = selectedUser.email;
      data.maCreatedByPreferredName = selectedUser.preferredName;
      data.maUserAffiliateCompanyBranchShortName = selectedUser.companyBranchShortName;
      data.maUserAffiliateCompanyBranchID = selectedUser.companyBranchID;
      data.maUserAffiliateCompanyID = selectedUser.companyID;
      data.maUserAffiliateID = selectedUser.affiliateID;
      data.maUserID = selectedUser.id;
      this.setState({ data }, () => {
        this.handleCheckChanges('bookingChanges');
      });
    }
  }
  handleUserfetch = (data, searchUserValue) => {
    this.setState({ searchUsersData: data, searchUserValue });
  }
  handleBookingStatusChange = (event, value) => {
    const { data, oriData, projectBookingCustomFields } = this.state;
    const { t } = this.props;
    const newStatusID = value.value;

    if (projectBookingCustomFields && projectBookingCustomFields.length > 0) {
      const missingFields = [];

      projectBookingCustomFields.forEach((field) => {
        // Status-based validation only applies to custom fields
        if (field.isDefault) {
          return;
        }

        if (this.isCustomFieldRequiredAtStatus(field, newStatusID)) {
          const fieldValue = data[this.bcfPRefix(field.name)];
          if (!fieldValue || fieldValue === '' || (Array.isArray(fieldValue) && fieldValue.length === 0)) {
            missingFields.push(field.label);
          }
        }
      });

      if (missingFields.length > 0) {
        const { store } = this.context;
        const fieldList = missingFields.join(', ');
        store.dispatch(flashErrorMessage({
          header: t('Required Fields Missing', { ns: TRANSLATION_FILES.translation }),
          message: t('Please fill in all required fields before changing status: {{fields}}', { fields: fieldList, ns: TRANSLATION_FILES.translation }),
        }));
        return;
      }
    }

    // Disabled: no place to enter a payment on a Vietnamese Sales Overview since CPI-974; re-enable when the payment section returns.
    // // CPI-974 item 18: refuse the transition; the API's UpdateBooking is the authoritative reject.
    // if (this.isBookingStatusBlockedByPayment(value.value)) {
    //   const { store } = this.context;
    //   store.dispatch(flashErrorMessage({
    //     message: t('Payment must be approved before changing the status to {{statuses}}', {
    //       statuses: this.getBlockedBookingStatusLabels([value.value]),
    //       ns: TRANSLATION_FILES.translation,
    //     }),
    //   }));
    //   return;
    // }
    // CPI-976: refuse Booked while the signature is missing; evaluated after the payment gate.
    if (this.isBookingStatusBlockedBySignature(value.value)) {
      const { store } = this.context;
      store.dispatch(flashErrorMessage({
        message: t('The purchaser must sign the sales form before the status can change to Booked', { ns: TRANSLATION_FILES.translation }),
      }));
      return;
    }
    const { requireValidTinAtBookingAndSold, requireValidTinAtSold, tinSettingBookingStartAt } = oriData.project;
    const shouldCheckAllCustomersTIN = (
      (newStatusID === 'sold_spa_signed' && (requireValidTinAtBookingAndSold || requireValidTinAtSold)) ||
      (newStatusID === 'booked' && requireValidTinAtBookingAndSold)
    ) && (
      tinSettingBookingStartAt === null ||
      new Date(data.createdAt) >= new Date(tinSettingBookingStartAt)
    );
    if (shouldCheckAllCustomersTIN) {
      // skip passport purchaser
      const allTINValidated = data.bookingCustomers.every(bc => bc.customer.identityTypeID === 2 || bc.customer.taxTinValidationStatus === 'success');
      if (!allTINValidated) {
        // show warning
        const newBookingStatusText = BOOKING_STATUSES.find(status => status.value === newStatusID).text || '';
        this.setState({ data, tinInvalidModal: true, newBookingStatus: newBookingStatusText });
        return;
      }
    }

    data[value.name] = value.value;
    if (data[value.name] !== oriData[value.name]) {
      this.setState({ data, bookingStatusModal: true });
    }
  }
  handleNotesChange = (bnEncoded) => {
    const { data } = this.state;
    data.newBookingNoteEncoded = bnEncoded;
    data.remarkInternal = '';
    this.setState({ data });
  }
  handleNotesCheckboxChange = (e, { name, checked }) => {
    const { data } = this.state;
    if (name === 'delistOnHold') {
      data.projectUnit[name] = checked;
    } else {
      data[name] = checked;
    }

    this.setState({ data });
  }
  handleConfirmBookingStatus = async (e, d) => {
    const { data, pendingChangeUnitData, isUnitChange } = this.state;
    const { store } = this.context;
    const { t } = this.props;

    // If this is a unit change, execute the change unit API first
    if (isUnitChange && pendingChangeUnitData) {
      // Guard against double press while the request is in flight
      if (this.unitChangeInFlight) {
        return;
      }
      this.unitChangeInFlight = true;
      await this.setLoading(true);

      const b = {
        projectID: pendingChangeUnitData.projectID,
        projectUnitID: pendingChangeUnitData.projectUnitID,
        cuFollowPrevBookingDateIsEnabled: pendingChangeUnitData.cuFollowPrevBookingDateIsEnabled,
      };

      let res = '';
      try {
        res = await store.dispatch(fetchM(`/bookings/${this.state.data.id}/unit/`, {
          credentials: 'include',
          method: 'PUT',
          // CPI-1347: a refused change-unit is a business rule, not a page permission; show the
          // server's message in the catch below instead of leaving the booking for /forbidden/.
          ignoreForbidden: true,
          headers: {
            'Content-Type': 'application/json',
            'X-Csrf-Token': this.props.token,
          },
          body: JSON.stringify(b),
        }));
      } catch (err) {
        this.unitChangeInFlight = false;
        await this.setLoading(false);
        if (err.res && err.res.status >= 400 && err.res.status < 500) {
          const message = await err.res.text();
          store.dispatch(flashErrorMessage({ message }));
          return;
        }
        Bugsnag.notifyException(err);
        store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
        return;
      }

      const newBooking = await res.json();

      // Upload attachments if any
      let uploadResult = {
        total: 0,
        uploaded: 0,
        failed: 0,
      };
      if (config.get('server') !== 'development' && pendingChangeUnitData.attachmentsUploadedCount > 0) {
        uploadResult = await this.handleUploadSecureDocuments(
          newBooking.id,
          pendingChangeUnitData.attachmentsUploaded,
          pendingChangeUnitData.attachmentsUploadedCount,
        );
      }

      // Store new booking ID for cancellation
      data.newID = newBooking.id;

      await this.setLoading(false);

      store.dispatch(flashSuccessMessage({
        header: t('Unit Change Success', { ns: TRANSLATION_FILES.translation }),
        message: t('Booking {{code}} successfully created via Unit Change', { code: newBooking.code, ns: TRANSLATION_FILES.translation }),
      }));

      // TODO: do we need to display this message?
      // if (uploadResult.total > 0 && uploadResult.failed > 0) {
      //   store.dispatch(flashErrorMessage({
      //     header: t('Attachment Upload Incomplete', { ns: TRANSLATION_FILES.translation }),
      //     message: t('{{uploaded}}/{{total}} attachment(s) uploaded. Please retry upload for failed file(s).', {
      //       uploaded: uploadResult.uploaded,
      //       total: uploadResult.total,
      //       ns: TRANSLATION_FILES.translation,
      //     }),
      //   }));
      // }
    }

    // Continue with original booking status update
    let booking = data;
    booking[d.name] = d.name;
    if (data.statusID === 'sold_spa_signed' || data.statusID === 'cancelled_developer') {
      booking.isCancelPending = data.isCancelPending;
      booking.isUserCooldown = data.isUserCooldown;
    }
    booking = this.setPricePerSqm(booking);
    this.setState({ bookingStatusModal: false, isUnitChange: false, pendingChangeUnitData: null }, () => {
      this.unitChangeInFlight = false;
      this.updateBooking(booking, 'update');
    });
    this.callRefreshBookingNote();
  }
  handleCancelBookingStatus = () => {
    const { data, oriData } = this.state;
    data.statusID = oriData.statusID;
    data.newBookingNoteEncoded = '';
    this.setState({
      data,
      bookingStatusModal: false,
      isUnitChange: false,
      pendingChangeUnitData: null,
    });
  }
  handleCancelTinInvalidModal = (e) => {
    e.preventDefault();
    this.setState({ tinInvalidModal: false });
  }
  getMinCancelledDate = (data) => {
    // Return the minimum date for cancelledAt to be sold date if it exist
    if (data.lastSoldAt) {
      return moment(data.lastSoldAt).startOf('day').toDate();
    // Else return the minimum date for cancelledAt to be approved date if it exist
    } else if (data.approvedAt) {
      return moment(data.approvedAt).startOf('day').toDate();
    // Else return the minimum date for cancelledAt to be created date if it exist
    } else if (data.createdAt) {
      return moment(data.createdAt).startOf('day').toDate();
    }
    return null;
  }
  getMinSoldDate = data => data.createdAt ? moment(data.createdAt).startOf('day').toDate() : null
  handleOnVisible = (field) => {
    const { data } = this.state;
    const updatedState = { ...this.state };

    // Set visibility for date pickers
    if (field === 'approvedAt') {
      updatedState.approvedDatePickerVisible = true;
      updatedState.minSoldDate = this.getMinSoldDate(data);
      updatedState.minCancelledDate = this.getMinCancelledDate(data);
    } else if (field === 'cancelledAt') {
      updatedState.cancelledDatePickerVisible = true;
      updatedState.minCancelledDate = this.getMinCancelledDate(data);
    } else if (field === 'lastSoldAt') {
      updatedState.soldDatePickVisible = true;
      updatedState.minSoldDate = this.getMinSoldDate(data);
      updatedState.minCancelledDate = this.getMinCancelledDate(data);
    } else if (field === 'spaSigningDate') {
      updatedState.spaSigningDatePickerVisible = true;
      updatedState.minSoldDate = this.getMinSoldDate(data);
      updatedState.minCancelledDate = this.getMinCancelledDate(data);
    } else if (field === 'spaStampingDate') {
      updatedState.spaStampingDatePickerVisible = true;
      updatedState.minSoldDate = this.getMinSoldDate(data);
      updatedState.minCancelledDate = this.getMinCancelledDate(data);
    }

    this.setState(updatedState);
  }
  handleOnClear = (field) => {
    const { data } = this.state;
    data[field] = null;
    this.setState({ data });
  }
  handleBookingDateChanges = (value, visible, field) => {
    const { data } = this.state;
    data[field] = value;
    const updatedState = { ...this.state };

    if (field === 'approvedAt') {
      updatedState.approvedDatePickerVisible = visible;
      updatedState.minSoldDate = value || this.getMinSoldDate(data);
    } else if (field === 'cancelledAt') {
      updatedState.cancelledDatePickerVisible = visible;
      updatedState.minCancelledDate = this.getMinCancelledDate(data);
    } else if (field === 'lastSoldAt') {
      updatedState.soldDatePickVisible = visible;
      updatedState.minSoldDate = this.getMinSoldDate(data);
    } else if (field === 'spaSigningDate') {
      updatedState.spaSigningDatePickerVisible = visible;
      updatedState.minSoldDate = this.getMinSoldDate(data);
    } else if (field === 'spaStampingDate') {
      updatedState.spaStampingDatePickerVisible = visible;
      updatedState.minSoldDate = this.getMinSoldDate(data);
    }

    this.setState(updatedState);
  }
  submit(url, opts) {
    return this.form.submit(url, opts);
  }
  valueToText = (array, value) => {
    const element = array.find(a => a.value === value);
    if (element && element.text) {
      return element.text;
    }
    return '';
  }
  handleCloseLarge = (e) => {
    e.preventDefault();
    this.setState({
      showLarge: false,
      selectedPicture: null,
      slideshow: false,
    });
  }
  handleSlidePicture = (e, direction = 'right') => {
    const { data, selectedPicture } = this.state;
    const index = data.paymentPictures.indexOf(selectedPicture);
    const nextIndex = direction === 'left' ? index - 1 : index + 1;
    this.setState({
      selectedPicture: data.paymentPictures[nextIndex],
    });
  }

  handleEditPPModalSubmit = (selectedPackagePricingItem, name) => this.setState({ [name]: selectedPackagePricingItem });

  checkAllowChangeUnit = () => {
    const { oriData } = this.state;
    return oriData && oriData.project && oriData.project.cuIsEnabled && this.hasAccessChangeUnit();
  }
  checkJSONStringifyMatch = (dataA, dataB) => {
    let match = false;
    try {
      if (JSON.stringify(dataA) === JSON.stringify(dataB)) match = true;
    } catch (e) {
      Bugsnag(e);
    }
    return match;
  }
  checkDisabled(direction = 'right') {
    const { data, selectedPicture } = this.state;
    if (data.paymentPictures.length > 0 && selectedPicture) {
      const index = data.paymentPictures.indexOf(selectedPicture);
      if (direction === 'left') {
        return index - 1 >= 0;
      }
      return index + 1 < data.paymentPictures.length;
    }
    return false;
  }
  checkCustomFieldsChanged = (bookingCustomFields, projectBookingCustomFields, data) => {
    let found = false;
    if (bookingCustomFields) {
      bookingCustomFields.forEach((d) => {
        if (d.value !== data[d.projectBookingCustomField.name]) found = true;
      });
    }
    if (projectBookingCustomFields) {
      projectBookingCustomFields.forEach((d) => {
        let exists = -1;
        if (bookingCustomFields) exists = bookingCustomFields.findIndex(bcfData => bcfData.projectBookingCustomFieldID === d.id);
        if (exists === -1) found = true;
      });
    }
    return found;
  }
  checkStaffHasStatusAccess = () => {
    const auth = this.props.auth;
    const { data } = this.props.appConfig;
    if (auth && auth.isDeveloperStaff && data && data.settings && data.settings.allowStaffEditBookingStatus) return true;
    return false;
  }
  handleSaveCreatedAt = (e, createdAt) => {
    this.setState({ showDateTimeModal: false }, () => {
      const { oriData } = this.state;
      const booking = {};
      booking.id = oriData.id;
      booking.createdAt = createdAt;
      this.updateBooking(booking, 'update');
    });
  }
  handleCancelCreatedAt = (e) => {
    e.preventDefault();
    this.setState({ showDateTimeModal: false });
  }
  handleOpenCreatedAt = (e) => {
    e.preventDefault();
    this.setState({ showDateTimeModal: true });
  }
  handleToggleCustomFields = (e) => {
    e.preventDefault();
    this.setState({ showCustomFields: !this.state.showCustomFields });
  }
  handleCustomSelectChange = (e, d, customFieldOptions, cValidation) => {
    const { data } = this.state;
    if (Array.isArray(d.value)) {
      const ids = [];
      const values = [];
      customFieldOptions.forEach((cfo) => {
        d.value.forEach((v) => {
          if (v === cfo.value) {
            ids.push(cfo.id);
            values.push(cfo.value);
          }
        });
      });
      data[`${d.name}OptionIDs`] = ids;
      data[`${d.name}OptionID`] = '';
      data[d.name] = values.join(',');
    } else {
      data[d.name] = d.value;
      const selectedOption = customFieldOptions.find(cfoData => cfoData.value === d.value);
      data[`${d.name}OptionID`] = selectedOption ? selectedOption.id : '';
      data[`${d.name}OptionIDs`] = [];
    }
    this.customFieldValidation = cValidation;
    this.setState({ data }, () => {
      this.handleCheckChanges('bookingChanges');
    });
  }
  handleCustomInputChange = (e, cValidation) => {
    const { data } = this.state;
    data[e.target.name] = e.target.value;
    this.customFieldValidation = cValidation;
    this.setState({ data }, () => {
      this.handleCheckChanges('bookingChanges');
    });
  }
  handleSubmitNoetic = (e) => {
    e.preventDefault();
    this.submitNoetic();
  }
  handleSubmitIFCA = (e) => {
    e.preventDefault();
    this.submitIFCA();
  }
  handleSubmitInsoft = (e) => {
    e.preventDefault();
    this.submitInsoft();
  }
  handleRecalculatePackagePricing = (b) => {
    const { data } = this.state;
    data.forceRecalculatePackagePricing = b;
    this.setState({ data });
  }
  handleCloseValidationSvcErrModal = (e) => {
    e.preventDefault();
    this.setState({ validationSvcErrorModalOpen: false });
  }
  handleOpenValidationSvcErrModal = async (e) => {
    e.preventDefault();
    await this.fetchJDELogs();
    await this.setComponentState({ validationSvcErrorModalOpen: true });
  }
  handleToggleExternalSvcErrModal = (toggle = false) => {
    this.setState({ externalSvcErrorModalOpen: toggle });
  }
  handleToggleAPIESvcErrModal = (toggle = false) => {
    this.setState({ apieSvcErrorModalOpen: toggle });
  }
  handleToggleBotSvcErrModal = (toggle = false) => {
    this.setState({ botSvcErrorModalOpen: toggle });
  }
  handleToggleBotResyncModal = (toggle = false) => {
    this.setState({ botResyncModalOpen: toggle });
  }
  handleResyncToBotApi = () => {
    this.handleToggleBotResyncModal(false);
    this.resyncBotApi();
  }
  handleBotResync = () => {
    const { oriData } = this.state;
    if (oriData && oriData.botServiceStatus === 'failed') {
      this.handleResyncToBotApi();
    } else {
      this.handleToggleBotResyncModal(true);
    }
  }
  renderBotResyncModal = () => {
    const { t } = this.props;
    return (
      <Modal
        className="booking-status-note"
        closeOnDimmerClick={false}
        onClose={() => this.handleToggleBotResyncModal(false)}
        open={this.state.botResyncModalOpen}
        size="tiny"
      >
        <Header content="Are you sure you want to re-sync?" />
        <Modal.Content>
          <Modal.Description>
            Re-syncing a booking may cause duplicates if there is a pending job running.
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button negative onClick={() => this.handleToggleBotResyncModal(false)} content={t('Cancel', { ns: TRANSLATION_FILES.translation })} />
          <Button positive onClick={this.handleResyncToBotApi} content="Re-sync" />
        </Modal.Actions>
      </Modal>
    );
  }
  checkAndRenderBotResyncButton = () => {
    const { oriData, isBotSyncing } = this.state;
    if (oriData && oriData.botServiceStatus !== '' && oriData.botServiceStatus !== 'success') {
      return (
        <div className="bot-button-div">
          <br />
          <Button
            className={`api-action-button ${isBotSyncing ? 'bot-syncing-button' : 'bot-resync-button'}`}
            disabled={isBotSyncing}
            size="small"
            onClick={isBotSyncing ? null : this.handleBotResync}
            compact
          >
            {
              isBotSyncing ? (
                <div className="bot-syncing-div">
                  <div className="bot-loader" />
                  <span> Syncing...</span>
                </div>
              ) : (
                <div>
                  <Icon name="redo" /> Resync
                </div>
              )
            }
          </Button>
        </div>
      );
    }
    return null;
  }
  handleToggleHimsSvcErrModal = (toggle = false) => {
    this.setState({ himsSvcErrorModalOpen: toggle });
  }
  handleResyncToHimsApi = () => {
    const { oriData } = this.state;

    // force to start a new sync
    if (oriData.himsHasChanges) {
      this.syncToHimsAPI();
      return;
    }

    if (oriData.himsServiceStatus === 'failed') {
      this.resyncHimsAPI();
      return;
    }
    this.syncToHimsAPI();
  }
  checkAndRenderHimsResyncButton = () => {
    const { oriData, isHimsSyncing } = this.state;
    if (!oriData) {
      return null;
    }

    const isActiveBooking = oriData.statusID === 'booked' || oriData.statusID === 'sold_spa_signed';
    if (!oriData.himsServiceID && !isActiveBooking) {
      return null;
    }

    const hasHimsFields = oriData.himsDeveloperCode !== '' && oriData.himsProjectDevelopmentID !== '' && oriData.himsUnitComponentID !== '' && oriData.himsUnitNumber !== '';
    if (!hasHimsFields) {
      return null;
    }

    if (oriData.himsServiceID && !(oriData.himsHasChanges || oriData.himsServiceStatus === 'failed')) {
      return null;
    }

    return (
      <div className="bot-button-div">
        <br />
        <Button
          className={isHimsSyncing ? 'bot-syncing-button' : 'bot-resync-button'}
          disabled={isHimsSyncing}
          size="small"
          onClick={isHimsSyncing ? null : this.handleResyncToHimsApi}
          compact
        >
          {
            isHimsSyncing ? (
              <div className="bot-syncing-div">
                <div className="bot-loader" />
                <span> Syncing...</span>
              </div>
            ) : (
              <div>
                <Icon name="redo" /> {oriData.himsServiceID ? 'Re-sync' : 'Sync to HIMS'}
              </div>
            )
          }
        </Button>
      </div>
    );
  }
  showNoetic() {
    if (this.props.appConfig.data.noeticIsEnabled) {
      return true;
    }
    return false;
  }
  showNoeticButton = (oriData) => {
    if ((oriData.statusID === 'booked' || oriData.statusID === 'sold_spa_signed') && this.hasAccess(false, true, true, true, false)) {
      return true;
    }
    return false;
  }
  showIFCA() {
    if (this.props.appConfig.data.ifcaIsEnabled) {
      return true;
    }
    return false;
  }
  showIFCAButton = (oriData) => {
    if (oriData.statusID === 'sold_spa_signed' && this.hasAccess(false, true, true, true, false)) {
      return true;
    }
    return false;
  }
  showInsoft() {
    if (this.props.appConfig.data.insoftIsEnabled) {
      return true;
    }
    return false;
  }
  showInsoftButton = (oriData) => {
    if (oriData.statusID === 'sold_spa_signed' && this.hasAccess(false, true, true, true, false)) {
      return true;
    }
    return false;
  }
  showRagic() {
    if (this.props.appConfig.data.ragicIsEnabled) {
      return true;
    }
    return false;
  }
  showExternalService() {
    if (this.props.appConfig.data.externalServiceIsEnabled) {
      return true;
    }
    return false;
  }
  showExternalResendButton = (oriData) => {
    if (
      oriData.externalServiceStatus !== 'Success'
      && this.props.appConfig.data.externalServiceIsEnabled
      && (this.hasAccess(false, true, true, false, false) || this.props.appConfig.data.isUem)
      && !this.props.appConfig.data.advelsoftIsEnabled
    ) {
      return true;
    }
    return false;
  }
  showAPIEService() {
    if (this.props.appConfig.data.apieServiceIsEnabled) {
      return true;
    }
    return false;
  }
  showBotService() {
    const { oriData } = this.state;
    return oriData && oriData.project && oriData.project.isBotEnabled;
  }
  showDiscountPricing = (oriData) => {
    if (oriData.tierPricingName !== 'Base' && oriData.tierPricingName !== '') {
      return true;
    }
    return false;
  }
  showHimsService = () => {
    const { appConfig } = this.props;
    const { oriData } = this.state;
    return appConfig && appConfig.data && appConfig.data.himsIsEnabled && oriData && oriData.project && oriData.project.himsIsEnabled;
  }
  hasChangeUnitAccess = oriData => (!oriData.newID && !vnChangeUnitBlocked(this.props.auth, oriData) && !reservationBlocked(this.props.auth, oriData.project) && (oriData.statusID === 'reserved' || oriData.statusID === 'booked') && (this.hasAccess(false, true, true, true, false) || this.checkAllowChangeUnit()))
  handleShowChangeUnit = () => {
    const { oriData } = this.state;
    this.setState({
      showChangeUnit: true,
      changeProjectID: oriData.projectID || '',
      changeUnitID: '',
    }, () => {
      if (this.state.projectOpts.length <= 0) {
        if (this.checkAllowChangeUnit() && oriData.project.cuOtherProjectIsEnabled) this.fetchProjects();
        else {
          let { projectOpts } = this.state;
          projectOpts = [{ value: oriData.project.id, text: oriData.project.name }];
          this.setComponentState({ projectOpts });
        }
      }
      if (this.state.changeProjectID && this.checkAllowChangeUnit()) {
        this.fetchUnits();
      }
    });
  }
  handleHideChangeUnit = () => {
    this.setState({ showChangeUnit: false });
  }
  handleSelectChangeProject = (e, { value }) => {
    this.setState({
      changeProjectID: value,
      changeUnitID: '',
    }, () => {
      this.fetchUnits();
    });
  }
  handleSelectChangeUnit = (e, { value }) => {
    this.setState({ changeUnitID: value });
  }
  handleShowConfirmChangeUnit = () => {
    this.setState({
      bookingChangeUnitModal: true,
      showChangeUnit: false,
    });
  }
  handleCancelChangeUnit = () => {
    this.setState({ bookingChangeUnitModal: false });
  }
  handleConfirmChangeUnit = (value) => {
    this.setState({ bookingChangeUnitModal: false }, () => {
      this.submitChangeUnit(value);
    });
  }
  handleBookingNotesExpand = (expand = false) => {
    this.setState({ bookingNotesModuleExpand: expand }, () => {
      if (expand) {
        const bnColDiv = document.getElementById('bn_grid_col_div');
        if (bnColDiv) {
          bnColDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    });
  }
  optionsTierPricings = () => {
    const { t } = this.props;
    const tiers = this.state.unitTiers || [];
    // Setup pricingTiers
    const pricingTiers = [{
      value: this.state.data.projectUnit ? spaFullNumber(this.state.data.projectUnit).toString() : '',
      description: this.state.data.projectUnit ? spaFullNumber(this.state.data.projectUnit).toString() : '',
      text: t('Base Selling Price'),
      content: (
        <Header className="ddPricingTierItem">
          <div className="name">{t('Base Selling Price')}</div>
          <div className="value"><CurrencySymbol />{this.state.data.projectUnit ? spaFullNumber(this.state.data.projectUnit).toString() : ''}</div>
        </Header>
      ),
    }];
    if (tiers) {
      tiers.sort((a, b) => a.position - b.position).forEach((d) => {
        const newItem = {
          description: d.totalPrice.toString(),
        };
        if (d.projectPricing) {
          newItem.text = d.projectPricing.name;
          newItem.value = d.projectPricing.id;
          newItem.content = (
            <Header className="ddPricingTierItem">
              <div className="name">{d.projectPricing.name}</div>
              <div className="value"><CurrencySymbol />{d.totalPrice.toString()}</div>
              <Header.Subheader>{d.projectPricing.description}</Header.Subheader>
            </Header>
          );
        }
        pricingTiers.push(newItem);
      });
    }
    // filter expired
    const newPricingTiers = pricingTiers;
    let tier;
    pricingTiers.forEach((pt, idx) => {
      if (tiers) tier = tiers.find(tt => tt.totalPrice.toString() === pt.description);
      if (tier) {
        const sStart = tier.projectPricing.scheduleStartAt;
        const sEnd = tier.projectPricing.scheduleEndAt;
        if ((sStart && moment(sStart).unix() > moment().unix()) ||
          (sEnd && moment(sEnd).unix() < moment().unix())) {
          if (!pt.disabled) {
            newPricingTiers[idx].disabled = true;
          }
        }
      }
    });
    return newPricingTiers;
  }
  checkSizeSuffix = () => {
    const { t } = this.props;
    const { data } = this.state;
    const suffix = data.project && data.project.sizeSuffix;
    switch (suffix) {
      case 'square_metres':
        return isVietnamCompany(this.props.auth) ? ' m²' : ` ${t('sqm', { ns: TRANSLATION_FILES.screens })}`;
      case 'square_feet':
        return ` ${t('sqft', { ns: TRANSLATION_FILES.screens })}`;
      default:
        return '';
    }
  }
  canRenderFirstTimeBuyer = data => (data.spaAmount <= 500000) && data.firstTimeBuyer === 'yes' && data.srpLoan !== ''
  canRenderNotesAndAPISection = (onlyAPI = false) => {
    const { data } = this.state;
    return isPRS ||
      this.showNoetic() ||
      this.showIFCA() ||
      this.showInsoft() ||
      this.showRagic() ||
      this.showExternalService() ||
      this.showBotService() ||
      this.showAPIEService() ||
      this.showHimsService() ||
      (!onlyAPI && data && data.project && this.hasBookingNoteReadAccess(data.project));
  }
  renderStatusDisabledTextWithCC = () => {
    const { t } = this.props;
    return this.hasAccess(this.checkStaffHasStatusAccess(), true, true, true, false) && (
      <Grid.Column textAlign="right" width={16}>
        <b>{t('Status update is disabled due to credit control')}.</b>
      </Grid.Column>
    );
  }
  renderPaymentApprovalRequiredText = () => {
    const { t } = this.props;
    const paymentApprovedRequiredStatusIDs = this.getPaymentApprovedRequiredStatusIDs();
    if (paymentApprovedRequiredStatusIDs.length === 0 || this.hasApprovedBookingPayment()) return null;
    const statuses = this.getBlockedBookingStatusLabels(paymentApprovedRequiredStatusIDs);
    return (
      <Grid.Column textAlign="right" width={16}>
        <b>{t('Payment must be approved before changing the status to {{statuses}}', { statuses, ns: TRANSLATION_FILES.translation })}.</b>
      </Grid.Column>
    );
  }
  renderSignatureRequiredText = () => {
    const { t } = this.props;
    if (!this.isBookingStatusBlockedBySignature('booked')) return null;
    return (
      <Grid.Column textAlign="right" width={16}>
        <b>{t('The purchaser must sign the sales form before the status can change to Booked', { ns: TRANSLATION_FILES.translation })}.</b>
      </Grid.Column>
    );
  }
  renderJDELogs = (oriData) => {
    const data = this.state.validationSvcErrorModalContent;
    if (data) {
      return (
        <div>
          <div>
            <h4>JDE API Buyer Response:</h4>
            <div>{data.buyerResponseRaw}</div>
            <br /><b><small>Request Sent At: {data.buyerRequestSentAt}</small></b>
          </div>
          <br />
          <hr />
          <br />
          <div>
            <h4>JDE API Property Response:</h4>
            <div>{data.propertyResponseRaw}</div>
            <br /><b><small>Request Sent At: {data.propertyRequestSentAt}</small></b>
          </div>
        </div>
      );
    }
    return oriData.validationServiceErrorMessage;
  }
  renderSvcErrorList = (data) => {
    const dataToArray = data.split(',').map(item => item.trim());
    const errorItems = dataToArray.reverse().map(d => <List.Item key={d}>{d}</List.Item>);
    return <List>{errorItems}</List>;
  }
  renderBotSvcError = (data) => {
    const errorItems = data.reverse().map(d => <List.Item key={d}>{d}</List.Item>);
    return <List>{errorItems}</List>;
  }
  renderCustomFields(isEditing, minItems = 0, offsetFrom = 0) {
    const { data, projectBookingCustomFields } = this.state;
    const { auth } = this.props;
    // combine both fields from booking and project to order them together
    let combineCustomFields = [];
    if (data && data.bookingCustomFields) {
      data.bookingCustomFields.map((d) => {
        const newD = d.projectBookingCustomField;
        newD.projectBookingCustomFieldOptions = d.projectBookingCustomFieldOptions;
        combineCustomFields.push(d.projectBookingCustomField);
      });
    }
    if (projectBookingCustomFields) projectBookingCustomFields.map(d => combineCustomFields.push(d));
    combineCustomFields = [...new Map(combineCustomFields.map(item => [item.id, item])).values()];
    // push deleted fields to the end of array as it is still shown if there is a previous value.
    combineCustomFields.forEach((d, idx) => {
      if (d.isDeleted) combineCustomFields[idx].position += 999;
    });
    if (data) {
      return (
        <div>
          <CustomFieldForm
            ref={this.customFieldFormRef}
            componentData={data}
            customFieldSettings={projectBookingCustomFields}
            countryCode={auth && auth.company ? auth.company.countryCode : ''}
            isEditing={isEditing}
            isBookingCustomField
            onCustomInputChange={this.handleCustomInputChange}
            onCustomSelectChange={this.handleCustomSelectChange}
            minItems={minItems}
            offsetFrom={offsetFrom}
          />
        </div>
      );
    }
    return '';
  }
  renderSoldCasePrompt = () => {
    const access = this.hasAccess(false, true, true, true, true);
    const { oriData } = this.state;
    const { t } = this.props;
    const soldCases = oriData.bankCases.filter(bankCase => bankCase.status === 'success_li_issued');
    if (access && oriData.statusID !== 'sold_spa_signed' && oriData.statusID !== 'expired' && oriData.statusID !== 'cancelled_developer' && oriData.statusID !== 'cancelled_availability' && soldCases.length > 0) {
      const bankerName = soldCases[0].banker.preferredName;
      const bankName = soldCases[0].bank.name;
      return (
        <Message warning style={{ margin: '1em 0' }}>
          <Grid columns="equal" verticalAlign="middle">
            <Grid.Column>
              <Trans ns={TRANSLATION_FILES.screens}>
                <strong>{{ bankerName }}</strong> from <strong>{{ bankName }}</strong> has updated Loan Status to <strong>LO Signed</strong>.
              </Trans>
            </Grid.Column>
            <Grid.Column width={4} textAlign="right">
              <Button
                size="small"
                positive
                onClick={e => this.handleBookingStatusChange(e, { name: 'statusID', value: 'sold_spa_signed' })}
                content={t('Mark Sold')}
              />
            </Grid.Column>
          </Grid>
        </Message>
      );
    }
    return null;
  }
  renderChangeUnitPrompt = () => {
    const { t } = this.props;
    const access = this.hasAccess(false, true, true, true, false) || this.checkAllowChangeUnit();
    const { oriData } = this.state;
    const isActiveBooking = oriData.statusID === 'reserved' || oriData.statusID === 'booked';
    if (access && isActiveBooking && oriData.newID) {
      return (
        <Message warning style={{ margin: '1em 0' }}>
          <Grid columns="equal" verticalAlign="middle">
            <Grid.Column>
              <Trans ns={TRANSLATION_FILES.screens}>
                A new <Link to={`/bookings/${oriData.newID}/`} target="_blank">booking</Link> is created via <strong>Unit Change</strong>
              </Trans>
            </Grid.Column>
            <Grid.Column width={4} textAlign="right">
              <Button
                size="small"
                negative
                onClick={e => this.handleBookingStatusChange(e, { name: 'statusID', value: 'cancelled_developer' })}
                content={t('Mark Cancelled')}
              />
            </Grid.Column>
          </Grid>
        </Message>
      );
    }
    return null;
  }
  renderAPISection = (t, oriData, isEditing) => (
    this.canRenderNotesAndAPISection(true) ? (
      <Grid>
        <Grid.Row>
          <Grid.Column mobile={16} tablet={16} computer={16} className="mobile-half-left-padding">
            <Dimmer style={{ zIndex: 10 }} active={isEditing} inverted />
            {
              this.showNoetic() &&
              <Message style={{ marginTop: '0.35em', padding: '0.5em 1em', textAlign: 'left' }}>
                <b>{`${translateModels(t, 'noeticStatusID', 'booking')}:`}</b> <small>{oriData.noeticStatusID ? getConstantsLabel(t, NOETIC_STATUSES, oriData.noeticStatusID) : 'N/A'}</small>
                <br />
                {
                  (oriData.noeticStatusID === 'none' || oriData.noeticStatusID === 'failed') ?
                    this.showNoeticButton(oriData) &&
                    <Button fluid size="small" className="api-action-button" onClick={this.handleSubmitNoetic}>{t(oriData.noeticStatusID === 'none' ? 'Send to {{name}}' : 'Retry send to {{name}}', { name: 'Noetic' })}</Button>
                    : oriData.noeticSalesID !== '' && <span><b>{`${translateModels(t, 'noeticStatusID', 'booking')}:`} </b> {oriData.noeticSalesID}</span>
                }
              </Message>
            }
            {
              this.showIFCA() &&
              <Message style={{ marginTop: '0.35em', padding: '0.5em 1em', textAlign: 'left' }}>
                <b>{`${translateModels(t, 'ifcaStatusID', 'booking')}:`}</b> <small>{oriData.ifcaStatusID ? getConstantsLabel(t, IFCA_STATUSES, oriData.ifcaStatusID) : 'N/A'}</small>
                <br />
                {
                  (oriData.ifcaStatusID === 'none' || oriData.ifcaStatusID === 'failed') ?
                    this.showIFCAButton(oriData) &&
                    <Button fluid size="small" className="api-action-button" onClick={this.handleSubmitIFCA}>{t(oriData.ifcaStatusID === 'none' ? 'Send to {{name}}' : 'Retry send to {{name}}', { name: 'IFCA' })}</Button>
                    : oriData.ifcaReferenceID !== '' && <span><b>{`${translateModels(t, 'ifcaReferenceID', 'booking')}:`} </b> {oriData.ifcaReferenceID}</span>
                }
              </Message>
            }
            {
              this.showInsoft() &&
              <Message style={{ marginTop: '0.35em', padding: '0.5em 1em', textAlign: 'left' }}>
                <b>{`${translateModels(t, 'insoftStatusID', 'booking')}:`}</b> <small>{oriData.insoftStatusID ? getConstantsLabel(t, INSOFT_STATUSES, oriData.insoftStatusID) : 'N/A'}</small>
                <br />
                {
                  (oriData.insoftStatusID === 'none' || oriData.insoftStatusID === 'failed') ?
                    this.showInsoftButton(oriData) &&
                    <Button fluid size="small" className="api-action-button" onClick={this.handleSubmitInsoft}>{t(oriData.insoftStatusID === 'none' ? 'Send to {{name}}' : 'Retry send to {{name}}', { name: 'Insoft' })}</Button>
                    : oriData.insoftReferenceID !== '' && <span><b>{`${translateModels(t, 'insoftReferenceID', 'booking')}:`} </b> {oriData.insoftReferenceID}</span>
                }
              </Message>
            }
            {
              this.showRagic() &&
              <Message style={{ marginTop: '0.35em', padding: '0.5em 1em', textAlign: 'left' }}>
                <b>Ragic Status</b> <small>{oriData.ragicStatus ? oriData.ragicStatus : 'n/a'}</small>
                <br />
                <span><b>Ragic Opportunity ID: </b> <small>{oriData.ragicOpportunityID || 'n/a'}</small></span>
                <br />
                {oriData.ragicServiceError && (
                  <span><b>Ragic Errors: </b> <small>{oriData.ragicServiceError || 'No errors.'}</small></span>
                )}
              </Message>
            }
            {
              this.showExternalService() &&
              <Message style={{ marginTop: '0.35em', padding: '0.5em 1em', textAlign: 'left' }}>
                <b>{this.props.appConfig.data.advelsoftIsEnabled ? 'Advelsoft Status:' : 'External Status:'}</b> <small>{oriData.externalServiceStatus || 'Pending'}</small>
                <br />
                <span><b>ID: </b> <small>{oriData.externalID || 'N/A'}</small></span>
                <br />
                {
                  !this.props.appConfig.data.advelsoftIsEnabled &&
                  <span><b>Lead ID: </b> <small>{oriData.externalLeadID || 'N/A'}</small></span>
                }
                {
                  oriData.externalServiceError &&
                  <span><b>{`${t('Error Logs')}:`} </b><Label as="button" size="small" compact onClick={() => this.handleToggleExternalSvcErrModal(true)}>View</Label></span>
                }
                {this.showExternalResendButton(oriData) && (
                  <div className="resend">
                    <Label as="button" size="small" compact onClick={() => this.resendBooking()}>{this.props.appConfig.data.isUem ? 'Resend' : 'Resync'}</Label>
                  </div>
                )}
                {
                  this.props.appConfig.data.advelsoftIsEnabled &&
                  oriData.externalServiceStatus !== 'Success' &&
                  (oriData.statusID === 'booked' || oriData.statusID === 'sold_spa_signed') && (
                    <div className="resend">
                      <Label as="button" size="small" compact onClick={() => this.resendFRHBooking()}>Resend</Label>
                    </div>
                  )
                }
              </Message>
            }
            {
              isPRS &&
              <Message style={{ marginTop: '0.35em', padding: '0.5em 1em', textAlign: 'left' }}>
                <b>{`${translateModels(t, 'validationServiceStatus', 'booking')}:`}</b> <small>{oriData.validationServiceStatus ? getConstantsLabel(t, JDE_STATUSES, oriData.validationServiceStatus) : 'N/A'}</small>
                <br />
                <span><b>ID: </b> <small>{oriData.validationServiceReferenceID}</small></span>
                <br />
                <span>
                  <b>{`${t('Logs')}:`} </b><Label as="button" size="small" compact onClick={this.handleOpenValidationSvcErrModal}>View</Label>
                  {
                    this.hasAccess(false, true, true, false, false) ?
                      (
                        <span>- <Label color="grey" as="button" size="small" compact onClick={() => this.resendJDEBooking()}>Manual Update</Label></span>
                      ) : ''
                  }
                </span>
              </Message>
            }
            {
              this.showBotService() && (
                <Message style={{ marginTop: '0.35em', padding: '0.5em 1em', textAlign: 'left' }}>
                  <b>BOT Sync Status:</b> <small style={{ fontWeight: 'bold', color: this.getColorText(oriData.botServiceStatus) }}>{titleCase(oriData.botServiceStatus) || 'N/A'}</small>
                  {this.checkAndRenderBotResyncButton()}
                  {oriData.botServiceID && <span><br /><b>ID: </b> <small>{oriData.botServiceID}</small></span>}
                  {oriData.botServiceErrors && oriData.botServiceErrors.length > 0 && <span><br /><b>Error Logs: </b><Label as="button" size="small" compact onClick={() => this.handleToggleBotSvcErrModal(true)}>View</Label></span>}
                  {oriData.botServiceUpdatedAt && <span style={{ color: 'gray' }} ><br /><small>Updated as of <Timestamp format="MMMM Do, YYYY, h:mm:ss a" timestamp={oriData.botServiceUpdatedAt} /> </small></span>}
                </Message>
              )
            }
            {
              this.showAPIEService() &&
              <Message style={{ marginTop: '0.35em', padding: '0.5em 1em', textAlign: 'left' }}>
                <span>
                  <b>{`APIE ${t('Error Logs')}:`} </b>
                  {oriData.apieServiceError && <Label as="button" size="small" compact onClick={() => this.handleToggleAPIESvcErrModal(true)}>View</Label>}
                </span>
              </Message>
            }
            {
              this.showHimsService() && (
                <Message style={{ marginTop: '0.35em', padding: '0.5em 1em', textAlign: 'left' }}>
                  <b>HIMS Sync Status:</b> <small style={{ fontWeight: 'bold', color: this.getColorText(!oriData.himsServiceID || oriData.himsHasChanges ? '' : oriData.himsServiceStatus) }}>{!oriData.himsServiceID || oriData.himsHasChanges ? 'Pending Sync' : (titleCase(symbolToSpace(oriData.himsServiceStatus)) || 'Pending Sync')}</small>
                  {this.checkAndRenderHimsResyncButton()}
                  {oriData.himsServiceID && <span><br /><b>ID: </b> <small>{oriData.himsServiceID}</small></span>}
                  {oriData.himsServiceErrors && oriData.himsServiceErrors.length > 0 && <span><br /><b>Error Logs: </b><Label as="button" size="small" compact onClick={() => this.handleToggleHimsSvcErrModal(true)}>View</Label></span>}
                  {oriData.himsServiceUpdatedAt && <span style={{ color: 'gray' }} ><br /><small>Updated as of <Timestamp format="MMMM Do, YYYY, h:mm:ss a" timestamp={oriData.himsServiceUpdatedAt} /> </small></span>}
                </Message>
              )
            }
          </Grid.Column>
        </Grid.Row>
      </Grid>
    ) : ''
  )
  render() {
    const {
      bookingPP,
      bookingFP,
      bookingStatusModal,
      bookingChangeUnitModal,
      newBookingStatus,
      tinInvalidModal,
      bookingNotesModuleExpand,
      data,
      editingBooking,
      oriData,
      projectBookingCustomFields,
      projectCurrencies,
      searchUserValue,
      showDateTimeModal,
      uploadModalState,
      mpUserDetails,
      mpUserLoading,
      validationSvcErrorModalOpen,
      externalSvcErrorModalOpen,
      apieSvcErrorModalOpen,
      botSvcErrorModalOpen,
      himsSvcErrorModalOpen,
      globalSettings,
      cancellationReasons,
      showChangeUnit,
      changeProjectID,
      changeUnitID,
      isUnitChange,
    } = this.state;
    const { appConfig, routeParamsID, t } = this.props;
    const hideFirstTimeBuyer = appConfig && appConfig.data && appConfig.data.settings && appConfig.data.settings.bookingHideFirstTimeBuyer;
    const allowEditingApprovedDate = this.hasAccess(false, false, true, false, false);
    const allowEditingCancelledDate = allowEditingApprovedDate && appConfig && appConfig.data && appConfig.data.settings && !appConfig.data.settings.disableCancelledDateEditing;
    const allowEditingSoldDate = allowEditingApprovedDate && appConfig && appConfig.data && appConfig.data.settings && !appConfig.data.settings.disableSoldDateEditing;
    const allowEditingSPADates = this.hasAccess(false, false, true, false, false);

    const packagePricingsModals = [
      {
        name: 'showEditPackageModal',
        title: `${oriData && oriData.packagePricing && oriData.packagePricing.id ? 'Edit' : 'Add'} pricing package`,
        content: ({ open, onClose }) => (
          <EditPackageModal
            onSubmit={pp => this.updateBookingPP(pp).then(() => onClose())}
            open={open}
            onClose={onClose}
            selectedPackagePricing={
              (oriData
              && oriData.packagePricing
              && oriData.packagePricing.projectPackagePricingID)
              || 'base_selling_price'
            }
            selectedCustomPPName={
              oriData
              && oriData.packagePricing
              && oriData.packagePricing.isCustomPrice
              && oriData.packagePricing.customName
            }
            auth={this.props.auth}
            packagePricings={bookingPP}
            isMobile={this.props.isMobile}
            bookingData={oriData}
            projectID={this.state.data.projectID}
          />
        ),
      },
      {
        name: 'showCustomiseFormulaModal',
        title: 'Customise formula(s)',
        content: ({ open, onClose }) => (
          <CustomiseFormulaModal
            onSubmit={calcs => this.updateBookingPPFormulas(calcs)}
            open={open}
            onClose={onClose}
            auth={this.props.auth}
            isMobile={this.props.isMobile}
            packagePricings={bookingPP}
            selectedPackagePricing={
              oriData
              && oriData.packagePricing
              && oriData.packagePricing.projectPackagePricingID
            }
            bookingData={oriData}
            serviceCompanyID={this.props.auth.company.service_company_id}
            globalSettings={globalSettings}
          />
        ),
      },
      {
        name: 'showEditFeePackageModal',
        title: `${oriData && oriData.packageFee && oriData.packageFee.id ? 'Edit' : 'Add'} additional fee package`,
        content: ({ open, onClose }) => (
          <EditFeePackageModal
            onSubmit={pp => this.updateBookingFP(pp)}
            open={open}
            onClose={onClose}
            selectedFeePackage={
              oriData
              && oriData.packageFee
              && oriData.packageFee.projectFeePackageID
            }
            auth={this.props.auth}
            feePackages={bookingFP}
            isMobile={this.props.isMobile}
            bookingData={oriData}
            t={this.props.t}
          />
        ),
      },
      {
        name: 'showCustomiseFeePackageFormulaModal',
        title: 'Customise fee formula(s)',
        content: ({ open, onClose }) => (
          <CustomiseFeePackageFormulaModal
            onSubmit={calcs => this.updateBookingFPFormulas(calcs)}
            open={open}
            onClose={onClose}
            auth={this.props.auth}
            isMobile={this.props.isMobile}
            selectedFeePackage={
              oriData
              && oriData.packageFee
              && oriData.packageFee.projectFeePackageID
            }
            bookingData={oriData}
            serviceCompanyID={this.props.auth.company.service_company_id}
          />
        ),
      },
    ];
    return (
      <Container className="no_margin">
        {
          isPRS ?
            <ModalNotice
              open={validationSvcErrorModalOpen}
              onClose={this.handleCloseValidationSvcErrModal}
              headerNode={`JDE ${t('Logs')}`}
              content={this.renderJDELogs(oriData)}
            />
            : ''
        }
        {
          this.showExternalService() ?
            <ModalNotice
              open={externalSvcErrorModalOpen}
              onClose={() => this.handleToggleExternalSvcErrModal(false)}
              headerNode={`External ${t('Error Logs')}`}
              content={oriData.externalServiceError ? this.renderSvcErrorList(oriData.externalServiceError) : ''}
            />
            : ''
        }
        {
          this.showAPIEService() ?
            <ModalNotice
              open={apieSvcErrorModalOpen}
              onClose={() => this.handleToggleAPIESvcErrModal(false)}
              headerNode={`APIE ${t('Error Logs')}`}
              content={oriData.apieServiceError ? this.renderSvcErrorList(oriData.apieServiceError) : ''}
            />
          : ''
        }
        {
          this.showBotService() ?
            <ModalNotice
              open={botSvcErrorModalOpen}
              onClose={() => this.handleToggleBotSvcErrModal(false)}
              headerNode="Bot Error Logs"
              content={oriData.botServiceErrors && oriData.botServiceErrors.length > 0 ? this.renderBotSvcError(oriData.botServiceErrors) : ''}
            />
          : ''
        }
        {
          this.showHimsService() ?
            <ModalNotice
              open={himsSvcErrorModalOpen}
              onClose={() => this.handleToggleHimsSvcErrModal(false)}
              headerNode="HIMS Error Logs"
              content={oriData.himsServiceErrors && oriData.himsServiceErrors.length > 0 ? (
                <HimsErrorLog
                  httpStatus={oriData.himsServiceHttpStatus}
                  response={oriData.himsServiceResponse}
                  action={oriData.himsServiceAction}
                  errors={oriData.himsServiceErrors}
                />
              ) : ''}
            />
          : ''
        }
        <ModalDateTimeForm
          headerNode={t('Booking Created Date', { ns: TRANSLATION_FILES.translation })}
          descriptionNode={data.code}
          label={t('Booking Created Date', { ns: TRANSLATION_FILES.translation })}
          placeholder={t('Click to set date', { ns: TRANSLATION_FILES.translation })}
          data={moment(oriData.createdAt)}
          onClose={this.handleCancelCreatedAt}
          onConfirm={this.handleSaveCreatedAt}
          open={showDateTimeModal}
        />
        <ESigningModal
          ref={(ref) => { this.signatureModal = ref; }}
          loading={this.state.loading}
          open={this.state.showSignModal}
          saveButton={
            <Button onClick={this.saveSignature} disabled={this.state.loading} positive color="green" content={t('Save', { ns: TRANSLATION_FILES.translation })} />
          }
          cancelButton={
            <Button onClick={this.handleOnCancel} disabled={this.state.loading} basic color="grey" content={t('Cancel', { ns: TRANSLATION_FILES.translation })} />
          }
        />
        <BookingStatusNotes
          onNotesChange={this.handleNotesChange}
          onCheckboxChange={this.handleNotesCheckboxChange}
          statusID={data.statusID}
          isCancelPending={data.isCancelPending}
          isUserCooldown={data.isUserCooldown}
          isUnitChange={isUnitChange}
          isDelistOnHold={data.projectUnit ? data.projectUnit.delistOnHold : false}
          onClose={this.handleCancelBookingStatus}
          onConfirm={this.handleConfirmBookingStatus}
          open={bookingStatusModal}
          data={data}
        />
        {this.renderBotResyncModal()}
        <BookingChangeUnit
          onClose={this.handleCancelChangeUnit}
          onConfirm={this.handleConfirmChangeUnit}
          open={bookingChangeUnitModal}
          data={oriData}
          changeProjectID={changeProjectID}
          changeSelectedProject={this.state.projectOpts.find(o => o.value === changeProjectID)}
          changeSelectedUnit={this.state.unitOpts.find(o => o.value === changeUnitID)}
        />
        <TinInvalidModal
          newBookingStatus={newBookingStatus}
          onClose={this.handleCancelTinInvalidModal}
          onConfirm={this.handleConfirmBookingStatus}
          open={tinInvalidModal}
        />
        <ViewLarge
          open={this.state.showLarge}
          onClose={this.handleCloseLarge}
          picture={this.state.selectedPicture}
          onSlide={this.handleSlidePicture}
          disabledLeft={!this.checkDisabled('left')}
          disabledRight={!this.checkDisabled('right')}
          slideshow={this.state.slideshow}
        />
        {
          packagePricingsModals.map(ppm => (
            <PackagingPricingModal
              key={ppm.name}
              modalState={this.state[ppm.name]}
              header={t(ppm.title)}
              loading={this.state.loading}
              onClose={() => this.toggleActiveStates(ppm.name, false)}
              content={ppm.content || null}
            />
          ))
        }
        {this.renderSoldCasePrompt()}
        {this.renderChangeUnitPrompt()}
        <Grid>
          <Dimmer style={{ zIndex: 10 }} active={this.state.loading} inverted>
            <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
          </Dimmer>
          <Grid.Row>
            <Grid.Column>
              <Divider hidden className="compact" />
              <EditableBox
                newHeader={t(isCountryVietnam(this.props.auth.company.countryCode) ? 'Sales' : 'Booking').toUpperCase()}
                editable={this.hasAccess(false, true, true, true, true) || this.hasEditBookingAccess(data.maUserID, data.statusID) || this.showAgentCuButton(data.statusID)}
                isEditing={this.state.editingBooking}
                loading={this.state.loading}
                buttonNode={this.showAgentCuButton(data.statusID) ? () => (
                  <Label
                    as="button"
                    attached="top right"
                    style={{
                      right: '0',
                      top: '0.4em',
                      cursor: showChangeUnit ? 'default' : 'pointer',
                      opacity: showChangeUnit ? 0.5 : 1,
                    }}
                    content={this.props.isMobile ? 'C. Unit' : 'Change Unit'}
                    icon="sign-in"
                    className={editingBooking ? '' : 'editable-button-new'}
                    onClick={showChangeUnit ? null : this.handleShowChangeUnit}
                  />
                ) : null}
                onEdit={this.handleEditBooking}
                onClick={this.handleUpdateBooking}
                onCancel={this.handleResetBooking}
                content={({ isEditing, onConfirm }) => (
                  <Grid>
                    {/* Top Area */}
                    <Grid.Row>
                      {/* First / Left Parent Section */}
                      <Grid.Column mobile={16} tablet={this.canRenderNotesAndAPISection() ? 9 : 16} computer={this.canRenderNotesAndAPISection() ? 11 : 16}>
                        <Grid>
                          {/* Info Area  */}
                          <Grid.Row>
                            {/* Left Area */}
                            <Grid.Column mobile={16} tablet={16} computer={8}>
                              <Grid>
                                <Grid.Row stretched centered>
                                  {/* Info Header */}
                                  <Grid.Column width={16}>
                                    <Dimmer style={{ zIndex: 10 }} active={isEditing} inverted />
                                    <Header as="h2" textAlign={isVietnamCompany(this.props.auth) ? 'left' : 'center'} style={{ marginTop: 0 }}>
                                      {data.code}
                                      <Header.Subheader
                                        {...this.getDataAttributes('bookingcreatedat', moment(data.createdAt).format('YYYYMMDD hh:mm:ss'), 'booking')}
                                        {...this.getDataAttributes('bookingupdatedat', moment(data.updatedAt).format('YYYYMMDD hh:mm:ss'), 'booking')}
                                        {...this.getDataAttributes('bookingreservedat', moment(data.createdAt).format('YYYYMMDD hh:mm:ss'), 'booking')}
                                      >
                                        <i>
                                          <Timestamp format="MMMM Do YYYY, h:mm a" timestamp={data.createdAt} />
                                          {this.hasAccess(false, true, false, false, false) &&
                                            <button
                                              className="a-button-blue"
                                              onClick={this.handleOpenCreatedAt}
                                            >
                                              <Icon name="edit" size="small" fitted style={{ marginLeft: '0.5rem' }} />
                                            </button>
                                          }
                                          <br />
                                          <small>
                                            <span
                                              {...this.getDataAttributes('salespersonname', oriData.maCreatedByName, 'salesperson')}
                                              {...this.getDataAttributes('salespersonagency', this.props.maUserAffiliateCompanyBranchName, 'salesperson')}
                                            >
                                              {createdByLabel(this.props.auth, t, translateModels(t, 'maCreatedByPreferredName', 'booking')).toLowerCase()}&nbsp;
                                            </span>
                                            {
                                              data.origin === 'marketplace' && this.hasMPDetailsAccess() ? (
                                                <Popup
                                                  on="click"
                                                  trigger={
                                                    <a>
                                                      {oriData.maCreatedByPreferredName}
                                                    </a>
                                                  }
                                                  onOpen={() => {
                                                    this.fetchMarketplaceUserDetails(oriData.maUserID);
                                                  }}
                                                  size="mini"
                                                  inverted
                                                  position="bottom right"
                                                  disabled
                                                  flowing
                                                >
                                                  {
                                                    mpUserLoading ? (
                                                      <Loader active inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
                                                    ) : (
                                                      <span style={{ fontSize: '15px' }}>
                                                        <div>{`${translateModels(t, 'fullName', 'mpUserDetails')}: ${mpUserDetails.fullName}`}</div>
                                                        <div>{`${translateModels(t, 'email', 'mpUserDetails')}: ${mpUserDetails.email}`}</div>
                                                        <div>{`${translateModels(t, 'mobile', 'mpUserDetails')}: ${mpUserDetails.mobilePrefix}${mpUserDetails.mobile}`}</div>
                                                        {
                                                          mpUserDetails.agencyName ? (
                                                            <div>{`${translateModels(t, 'agencyName', 'mpUserDetails')}: ${mpUserDetails.agencyName}`}</div>
                                                          ) : null
                                                        }
                                                        {
                                                          mpUserDetails.registrationNumber ? (
                                                            <div>{`${translateModels(t, 'registrationNumber', 'mpUserDetails')}: ${mpUserDetails.registrationNumber}`}</div>
                                                          ) : null
                                                        }
                                                      </span>
                                                    )
                                                  }
                                                </Popup>
                                              ) : this.hasAccess(false, true, true, false, false) ?
                                                <Link to={`/users/${oriData.maUserAffiliateID}/`} >
                                                  {oriData.maCreatedByPreferredName}
                                                </Link>
                                                : oriData.maCreatedByPreferredName
                                            }
                                            {
                                              data && data.origin && data.origin.includes('marketplace' || 'marketplace_') ?
                                                <Label size="mini" style={{ marginLeft: '0.5em', backgroundColor: '#e6fff2', color: '#008040' }}>
                                                  {data.origin.includes('') ? t(data.origin.includes('marketplace_') ? 'Showroom Buyer' : 'Marketplace Buyer') : null}
                                                </Label>
                                                : null
                                            }
                                          </small>
                                        </i>
                                      </Header.Subheader>
                                    </Header>
                                  </Grid.Column>

                                  {/* Signature */}
                                  {/* CPI-976: Vietnam has no salesperson self-sign ("should not be e-sign by salesperson");
                                      the API rejects PUT /bookings/:id/signature/ for VN companies - this hides the entry
                                      point. The purchaser's own pad on the Purchaser tab is a different control and stays. */}
                                  { !isCountryVietnam(this.props.auth.company.countryCode) && (
                                    <Grid.Column mobile={16} tablet={8} computer={16}>
                                      <Dimmer style={{ zIndex: 10 }} active={isEditing} inverted />
                                      {
                                        data && data.salesPersonSignAt ?
                                          <span>
                                            {t('Signed on')}&nbsp;
                                            <Timestamp
                                              timestamp={data.salesPersonSignAt}
                                            />&nbsp;
                                            <button onClick={e => this.handleSalesSign(e)} className="a-button-blue"><Icon name="edit" /></button>
                                          </span> :
                                          <span>
                                            <button onClick={e => this.handleSalesSign(e)} className="a-button-blue">{t('Sales Person E-Sign')}</button>
                                          </span>
                                      }
                                    </Grid.Column>
                                  )}

                                  {/* Change Unit */}
                                  <Grid.Column width={16} style={{ marginTop: '1em' }}>
                                    {
                                      showChangeUnit ? (
                                        <Grid stackable>
                                          <Grid.Row>
                                            <Grid.Column width={16}>
                                              <Dropdown
                                                disabled={!(this.checkAllowChangeUnit() && oriData.project.cuOtherProjectIsEnabled) || this.state.loading || this.state.loadingProject}
                                                fluid
                                                loading={this.state.loadingProject}
                                                name="changeProjectID"
                                                onChange={this.handleSelectChangeProject}
                                                options={this.state.projectOpts}
                                                placeholder={t('Find Project')}
                                                search
                                                selection
                                                value={changeProjectID}
                                              />
                                            </Grid.Column>
                                          </Grid.Row>
                                          <Grid.Row>
                                            <Grid.Column width={16}>
                                              <Dropdown
                                                disabled={!this.checkAllowChangeUnit() || this.state.loading || this.state.loadingUnit || this.state.loadingProject || !this.state.changeProjectID}
                                                fluid
                                                loading={this.state.loadingUnit}
                                                name="changeUnitID"
                                                onChange={this.handleSelectChangeUnit}
                                                options={this.state.unitOpts}
                                                placeholder={t('Find Unit')}
                                                search
                                                selection
                                                value={changeUnitID}
                                              />
                                            </Grid.Column>
                                          </Grid.Row>
                                          <Grid.Row>
                                            <Grid.Column mobile={16} tablet={8} computer={8}>
                                              <Button
                                                fluid
                                                size="small"
                                                icon="remove"
                                                content={t('Cancel', { ns: TRANSLATION_FILES.translation })}
                                                onClick={this.handleHideChangeUnit}
                                                disabled={this.state.loading}
                                              />
                                            </Grid.Column>
                                            <Grid.Column mobile={16} tablet={8} computer={8}>
                                              <Button
                                                fluid
                                                size="small"
                                                color="blue"
                                                icon="save"
                                                content={t('Change')}
                                                onClick={this.handleShowConfirmChangeUnit}
                                                disabled={!changeUnitID || this.state.loading}
                                              />
                                            </Grid.Column>
                                          </Grid.Row>
                                        </Grid>
                                      ) : (
                                        isEditing && this.hasChangeUnitAccess(oriData) &&
                                          <Button
                                            fluid
                                            size="small"
                                            color="blue"
                                            disabled={!this.checkAllowChangeUnit()}
                                            onClick={this.handleShowChangeUnit}
                                          >
                                            {t('Change Unit')}
                                          </Button>
                                      )
                                    }
                                  </Grid.Column>
                                </Grid.Row>
                                <RenderHiddenDivider />
                              </Grid>

                              <Grid>
                                <Grid.Row className="no-top-padding">
                                  <Grid.Column>
                                    <Dimmer style={{ zIndex: 9 }} active={isEditing} inverted />
                                    <Grid verticalAlign="middle">
                                      <Grid.Column textAlign="left" width={6}>
                                        <b>{t('Status')}</b>
                                      </Grid.Column>
                                      <Grid.Column textAlign="right" width={10}>
                                        {this.hasAccess(this.checkStaffHasStatusAccess(), true, true, true, false) ?
                                          <Form.Select
                                            disabled={this.isBookingStatusDisabled(data)}
                                            fluid
                                            name="statusID"
                                            onChange={this.handleBookingStatusChange}
                                            options={this.getBookingStatuses().map(s => ({
                                              ...s,
                                              text: t(s.text, { ns: TRANSLATION_FILES.constants }),
                                            }))}
                                            placeholder={t('Select {{title}}', { title: translateModels(t, 'statusID', 'booking') })}
                                            selectOnBlur={false}
                                            value={data.statusID}
                                          />
                                          : oriData.bookingStatus ? t(oriData.bookingStatus.name, { ns: TRANSLATION_FILES.constants }) : '-'
                                        }

                                      </Grid.Column>
                                      {
                                        this.isBookingStatusUpdateBlocked(data) ? (
                                          this.renderStatusDisabledTextWithCC()
                                        ) : null
                                      }
                                      {/* Disabled: no place to enter a payment on a Vietnamese Sales Overview since CPI-974; re-enable when the payment section returns. */}
                                      {/* {this.renderPaymentApprovalRequiredText()} */}
                                      {this.renderSignatureRequiredText()}
                                    </Grid>
                                    <RenderDivider />
                                    <Grid>
                                      <Grid.Column textAlign="left" width={8}>
                                        <b>{t('Unit')}</b>
                                      </Grid.Column>
                                      <Grid.Column textAlign="right" width={8} {...this.getDataAttributes('unitreference', data.projectUnit ? data.projectUnit.reference : '', 'unit')}>
                                        {
                                          data.projectUnit ?
                                            <div>
                                              <Link to={`/projects/${data.projectID}/units/${data.projectUnitID}/`}>
                                                {data.projectUnit.reference}
                                              </Link>
                                              &nbsp;
                                              {/* CPI-1269: one label for the unit's is_bumi flag, taken from Project > Unit -
                                                  "Foreign restricted" in Vietnam, "Bumi" everywhere else. */}
                                              {data.projectUnit.isBumi && <Label size="mini">{unitQuotaChipLabel(this.props.auth, t)}</Label>}
                                            </div>
                                            :
                                            '-'
                                        }
                                      </Grid.Column>
                                    </Grid>
                                    <RenderDivider />
                                    <Grid>
                                      <Grid.Column textAlign="left" width={8}>
                                        <b>{t('Layout')}</b>
                                      </Grid.Column>
                                      <Grid.Column textAlign="right" width={8}>
                                        {
                                          data.projectUnit ?
                                            <Link to={`/projects/${data.projectID}/layouts/${data.projectUnit.projectUnitLayoutID}/`}>
                                              {data.projectUnit.projectUnitLayout.name}
                                            </Link>
                                            :
                                            '-'
                                        }
                                      </Grid.Column>
                                    </Grid>
                                    <RenderDivider />
                                    <Grid>
                                      <Grid.Column textAlign="left" width={6}>
                                        <b>{t('Project')}</b>
                                      </Grid.Column>
                                      <Grid.Column textAlign="right" width={10} {...this.getDataAttributes('projectname', data.project ? data.project.name : '', 'project')}>
                                        {
                                          data.project ?
                                            <Link to={`/projects/${data.projectID}/`}>
                                              {data.project.name}
                                            </Link>
                                            :
                                            '-'
                                        }
                                      </Grid.Column>
                                    </Grid>
                                  </Grid.Column>
                                </Grid.Row>
                              </Grid>
                              <Divider className="small-hide large-hide compact" />
                            </Grid.Column>

                            {/* Right Area */}
                            <Grid.Column mobile={16} tablet={16} computer={8}>
                              <Form onSubmit={onConfirm}>
                                {isEditing && this.hasAccess(false, true, true, false, false) &&
                                  <Grid verticalAlign="middle">
                                    <Grid.Column textAlign="left" width={6}>
                                      <b>{createdByLabel(this.props.auth, t, translateModels(t, 'maCreatedByPreferredName', 'booking'))}</b>
                                    </Grid.Column>
                                    <Grid.Column width={10}>
                                      <SearchStaff
                                        onClear={this.handleUserClear}
                                        onSelect={this.handleUserSelect}
                                        selectedValue={this.getSelectedCreatorValue()}
                                        searchAll
                                        onFetch={this.handleUserfetch}
                                        value={searchUserValue}
                                        placeholder={`${t('Find User')}...`}
                                      />
                                    </Grid.Column>
                                  </Grid>
                                }
                                { isEditing && this.hasAccess(false, true, true, false, false) &&
                                  <RenderDivider />
                                }
                                <Grid verticalAlign="middle">
                                  <Grid.Column textAlign="left" width={6}>
                                    <b>{translateModels(t, 'assignedMaName', 'booking')}</b>
                                  </Grid.Column>
                                  <Grid.Column width={10}>
                                    {
                                      (isEditing && this.hasAccess()) ? (
                                        <SearchStaff
                                          onClear={this.handleStaffClear}
                                          onSelect={this.handleStaffSelect}
                                          selectedValue={this.getSelectedStaffValue()}
                                          auth={this.props.auth}
                                        />
                                      ) : (
                                        <div style={{ textAlign: 'right' }}>
                                          {
                                            oriData.assignedMaUserID > 0 ?
                                              `${oriData.assignedMaName} (${oriData.assignedMaPreferredName})`
                                              : '-'
                                          }
                                        </div>
                                      )
                                    }
                                  </Grid.Column>
                                </Grid>
                                <RenderDivider />
                                <Grid verticalAlign="middle">
                                  <Grid.Column textAlign="left" width={6}>
                                    <b>{translateModels(t, 'paymentMethodID', 'booking')}</b>
                                  </Grid.Column>
                                  <Grid.Column textAlign="right" width={10}>
                                    {
                                      (isEditing && this.hasAccessSourceOfFinance()) ?
                                        <Form.Select
                                          fluid
                                          name="paymentMethodID"
                                          options={(data.financeSourceOpts ? data.financeSourceOpts : paymentMethodOpts(this.props.auth)).map(opt => ({
                                            ...opt,
                                            text: t(opt.text, { ns: TRANSLATION_FILES.constants, defaultValue: opt.text }),
                                          }))}
                                          onChange={this.handleBookingChange}
                                          placeholder={t('Select {{title}}', { title: translateModels(t, 'paymentMethodID', 'booking') })}
                                          selectOnBlur={false}
                                          value={data.paymentMethodID}
                                        />
                                        : oriData.paymentMethod && oriData.paymentMethod.name ? t(oriData.paymentMethod.name, { ns: TRANSLATION_FILES.constants }) : '-'
                                    }
                                  </Grid.Column>
                                </Grid>
                                <RenderDivider />
                                {/* CPI-977 S3 (A55): the bank-guarantee waiver is chosen once, on
                                    the reservation form, and shown here for the audit trail. It is
                                    deliberately never editable from this screen - book-api refuses
                                    a change once the unit is Booked, and before that the
                                    reservation form is the one place that owns the choice. */}
                                {
                                  isVietnamCompany(this.props.auth) && (
                                    <React.Fragment>
                                      <Grid verticalAlign="middle">
                                        <Grid.Column textAlign="left" width={6}>
                                          <b>{translateModels(t, 'waiveBankGuarantee', 'booking')}</b>
                                        </Grid.Column>
                                        <Grid.Column textAlign="right" width={10}>
                                          {oriData.waiveBankGuarantee ? t('Yes') : t('No')}
                                        </Grid.Column>
                                      </Grid>
                                      <RenderDivider />
                                    </React.Fragment>
                                  )
                                }
                                {
                                  hideFirstTimeBuyer ? '' : (
                                    <Grid>
                                      <Grid.Column textAlign="left" width={6}>
                                        <b>{translateModels(t, 'firstTimeBuyer', 'booking')}</b>
                                      </Grid.Column>
                                      <Grid.Column textAlign="right" width={10}>
                                        {
                                          isEditing ?
                                            <Form.Select
                                              fluid
                                              name="firstTimeBuyer"
                                              options={FIRST_TIME_BUYER.map(l => ({
                                                ...l,
                                                text: t(l.text, { ns: TRANSLATION_FILES.constants }),
                                              }))}
                                              onChange={this.handleBookingChange}
                                              placeholder={`${translateModels(t, 'firstTimeBuyer', 'booking')}?`}
                                              selectOnBlur={false}
                                              value={data.firstTimeBuyer}
                                            />
                                            : (data.firstTimeBuyer ? getConstantsLabel(t, FIRST_TIME_BUYER, data.firstTimeBuyer) : '-')
                                        }
                                      </Grid.Column>
                                    </Grid>
                                  )
                                }
                                {hideFirstTimeBuyer ? '' : <RenderDivider />}
                                {
                                  this.canRenderFirstTimeBuyer(data) ?
                                    <Grid>
                                      <Grid.Column textAlign="left" width={isEditing ? 6 : 8}>
                                        <b>
                                          {translateModels(t, 'srpLoan', 'booking')}
                                          {/* <a title={t('About SRP Loan')} href="http://srp.com.my/en/about.html" target="_blank"><Icon name="info circle" color="blue" /></a> */}
                                        </b>
                                      </Grid.Column>
                                      <Grid.Column textAlign="right" width={isEditing ? 10 : 8}>
                                        {
                                          isEditing ?
                                            <Form.Select
                                              fluid
                                              name="srpLoan"
                                              options={SRP_LOAN_TYPE.map(l => ({
                                                ...l,
                                                text: t(l.text, { ns: TRANSLATION_FILES.constants }),
                                              }))}
                                              onChange={this.handleBookingChange}
                                              placeholder={`${translateModels(t, 'srpLoan', 'booking')}?`}
                                              selectOnBlur={false}
                                              value={data.srpLoan}
                                            />
                                            : (data.srpLoan ? getConstantsLabel(t, SRP_LOAN_TYPE, data.srpLoan) : '-')
                                        }
                                      </Grid.Column>
                                    </Grid>
                                    : ''
                                }
                                {this.canRenderFirstTimeBuyer(data) ? <RenderDivider /> : ''}
                                <Grid verticalAlign="middle">
                                  <Grid.Column textAlign="left" width={6}>
                                    <b>
                                      {
                                        globalSettings && globalSettings.sellingPrice
                                          ? globalSettings.sellingPrice
                                          : t('Selling Price')
                                      }
                                    </b>
                                  </Grid.Column>
                                  <Grid.Column textAlign="right" width={10}>
                                    {
                                      (isEditing && this.props.auth.allowEditUnitPrice && this.hasAccess(false, true, true, true, true)) ?
                                        <AppForm.Input
                                          validateLabel={t('Selling Price')}
                                          placeholder={t('Selling Price')}
                                          name="spaAmount"
                                          type="number"
                                          step=".01"
                                          value={data.spaAmount}
                                          onChange={this.handleBookingAmountChange}
                                          ref={this.validation.spaAmount}
                                          validation={[required]}
                                          disabled={this.disablePricingEditAfterSold(data)}
                                        />
                                        : (oriData.spaValue ?
                                          <LoanAmount
                                            projectCurrencies={projectCurrencies}
                                            format="0,000,000.00"
                                            amount={oriData.spaAmount}
                                            prefix={<CurrencySymbol />}
                                          />
                                          : '-')
                                    }
                                  </Grid.Column>
                                </Grid>
                                {
                                  (isEditing && this.props.auth.allowEditUnitPrice && this.hasAccess(false, true, true, true, true)) ?
                                    <div>
                                      <RenderDivider />
                                      <Grid verticalAlign="middle">
                                        <Grid.Column textAlign="left" width={6}>
                                          <b>
                                            {
                                              globalSettings && globalSettings.nettSellingPrice
                                                ? globalSettings.nettSellingPrice
                                                : translateModels(t, 'nettSellingPrice', 'booking')
                                            }
                                          </b>
                                        </Grid.Column>
                                        <Grid.Column textAlign="right" width={10}>
                                          <AppForm.Input
                                            validateLabel={translateModels(t, 'nettSellingPrice', 'booking')}
                                            placeholder={translateModels(t, 'nettSellingPrice', 'booking')}
                                            name="nettSellingPrice"
                                            type="number"
                                            value={data.nettSellingPrice}
                                            onChange={this.handleBookingAmountChange}
                                            ref={this.validation.nettSellingPrice}
                                            validation={[required, {
                                              validate: numericRange,
                                              option: {
                                                min: 1,
                                                max: 100000000000,
                                              },
                                            }]}
                                            min="1"
                                            step="0.01"
                                            disabled={this.disablePricingEditAfterSold(data)}
                                          />
                                        </Grid.Column>
                                      </Grid>
                                    </div>
                                    : ''
                                }
                                {
                                  (isEditing && this.showDiscountPricing(oriData) && this.props.auth.allowEditUnitPrice && this.hasAccess(false, true, true, true, true)) ?
                                    <RenderDivider />
                                    : ''
                                }
                                {
                                  (isEditing && this.showDiscountPricing(oriData) && this.props.auth.allowEditUnitPrice && this.hasAccess(false, true, true, true, true)) ?
                                    <Grid verticalAlign="middle">
                                      <Grid.Column textAlign="left" width={6}>
                                        <b>{t('Discount Pricing')}</b>
                                      </Grid.Column>
                                      <Grid.Column textAlign="right" width={10}>
                                        <Form.Select
                                          className="ddPricingTierDropdown"
                                          name="pricingTier"
                                          options={this.optionsTierPricings()}
                                          placeholder={t('Select {{title}}', { title: t('Discount Pricing') })}
                                          search
                                          selectOnBlur={false}
                                          value={this.getTierPricingValue()}
                                          onChange={this.handleTierPricingChange}
                                        />
                                      </Grid.Column>
                                    </Grid>
                                    : ''
                                }
                                {oriData.tierPricingName && <RenderDivider />}
                                {oriData.tierPricingName &&
                                  <Grid verticalAlign="middle">
                                    <Grid.Column textAlign="left" width={6}>
                                      <b>{t('Pricing Name')}</b>
                                    </Grid.Column>
                                    <Grid.Column textAlign="right" width={10}>
                                      {
                                        (isEditing && this.hasAccess(false, true, true, true, true)) ?
                                          <AppForm.Input
                                            validateLabel={t('Pricing Name')}
                                            placeholder={t('Pricing Name')}
                                            name="tierPricingName"
                                            value={data.tierPricingName}
                                            onChange={this.handleBookingChange}
                                            ref={this.validation.tierPricingName}
                                            disabled
                                          />
                                          : (oriData.spaValue ?
                                            <Popup
                                              trigger={
                                                <div className="priceName link">
                                                  {oriData.tierPricingName}
                                                </div>
                                              }
                                              content={oriData.tierPricingDescription}
                                              size="mini"
                                              inverted
                                              position="bottom right"
                                              disabled
                                            />
                                            : '-')
                                      }
                                    </Grid.Column>
                                  </Grid>
                                }
                                {isEditing && oriData.tierPricingName ? <RenderDivider /> : ''}
                                {isEditing && oriData.tierPricingName ?
                                  <Grid verticalAlign="middle">
                                    <Grid.Column textAlign="left" width={6}>
                                      <b style={{ color: '#999' }}>{t('Pricing Description')}</b>
                                    </Grid.Column>
                                    <Grid.Column textAlign="right" width={10}>
                                      <AppForm.Input
                                        validateLabel={t('Pricing Description')}
                                        placeholder={t('Pricing Description')}
                                        name="tierPricingDescription"
                                        value={data.tierPricingDescription}
                                        onChange={this.handleBookingChange}
                                        ref={this.validation.tierPricingDescription}
                                        disabled
                                      />
                                    </Grid.Column>
                                  </Grid>
                                  : ''
                                }
                                <RenderDivider />
                                <Grid verticalAlign="middle">
                                  <Grid.Column textAlign="left" width={6}>
                                    <b>{t('Price')} per {this.checkSizeSuffix()}</b>
                                  </Grid.Column>
                                  <Grid.Column width={10}>
                                    <div style={{ textAlign: 'right' }}>
                                      {
                                        data.projectUnit && data.projectUnit.size > 0 ?
                                          <LoanAmount
                                            projectCurrencies={projectCurrencies}
                                            format="0,000,000.00"
                                            amount={(data.spaAmount / data.projectUnit.size).toFixed(2)}
                                            prefix={<CurrencySymbol />}
                                          />
                                          : '-'
                                      }
                                    </div>
                                  </Grid.Column>
                                </Grid>
                                {this.showHimsService() && <RenderDivider />}
                                {
                                  this.showHimsService() && (
                                    <Grid verticalAlign="middle">
                                      <Grid.Column textAlign="left" width={6}>
                                        <b>HIMS {t('Price')} per {t('sqm')}</b>
                                      </Grid.Column>
                                      <Grid.Column width={10}>
                                        {
                                          (isEditing && this.hasAccess()) ? (
                                            <Form.Input
                                              fluid
                                              placeholder={`HIMS ${t('Price')} per ${t('sqm')}`}
                                              value={data.pricePerSqm}
                                              name="pricePerSqm"
                                              min="1"
                                              step="0.01"
                                              type="number"
                                              onChange={this.handleBookingChange}
                                              icon={
                                                <Icon
                                                  link
                                                  name="sync alternate"
                                                  onClick={this.handleResetPricePerSqm}
                                                />
                                              }
                                            />
                                          ) : (
                                            <div style={{ textAlign: 'right' }}>
                                              {
                                                data.pricePerSqm > 0 ?
                                                  <LoanAmount
                                                    projectCurrencies={projectCurrencies}
                                                    format="0,000,000.00"
                                                    amount={data.pricePerSqm}
                                                    prefix={<CurrencySymbol />}
                                                  />
                                                  : '-'
                                              }
                                            </div>
                                          )
                                        }
                                      </Grid.Column>
                                    </Grid>
                                  )
                                }
                                {((isEditing && this.hasAccess(false, true, true, true, true)) && oriData.remarkInternal) &&
                                  <RenderDivider />
                                }
                                {oriData.remarkInternal && isEditing ?
                                  <Grid verticalAlign="top">
                                    <Grid.Column textAlign="left" width={6}>
                                      <b>{translateModels(t, 'remarkInternal', 'booking')}</b>
                                    </Grid.Column>
                                    <Grid.Column textAlign="right" width={10}>
                                      <MarkdownText>{oriData.remarkInternal || '-'}</MarkdownText>
                                    </Grid.Column>
                                  </Grid>
                                  : null
                                }
                                <RenderDivider />
                                <Grid verticalAlign="middle">
                                  <Grid.Column textAlign="left" width={6}>
                                    <b>{translateModels(t, 'approvedAt', 'booking')}</b>
                                  </Grid.Column>
                                  <Grid.Column textAlign="right" width={10}>
                                    {
                                      isEditing && allowEditingApprovedDate ? (
                                        <Form.Input
                                          fluid
                                          placeholder={t('Click to set approved at date')}
                                          value={data.approvedAt ? moment(data.approvedAt).format(inputDateFormat) : ''}
                                          readOnly
                                          onFocus={() => this.handleOnVisible('approvedAt')}
                                          icon="calendar"
                                        />
                                      ) : null
                                    }
                                    {
                                     (isEditing && !allowEditingApprovedDate) || !isEditing ? (
                                        data.approvedAt ? (
                                          <Timestamp
                                            format="DD MMM YYYY"
                                            timestamp={moment(data.approvedAt).format()}
                                          />
                                        ) : '-'
                                      ) : null
                                    }
                                  </Grid.Column>
                                </Grid>
                                {
                                  isEditing && allowEditingApprovedDate ? (
                                    <Grid>
                                      <Grid.Column width={16}>
                                        <CalendarDatePicker
                                          closeableCompact={false}
                                          minDate={data.createdAt ? moment(data.createdAt).startOf('day').toDate() : null}
                                          maxDate={moment().toDate()}
                                          noPadding
                                          name="approvedAt"
                                          value={data.approvedAt ? moment(data.approvedAt).toDate() : null}
                                          onChange={(value, visible) => this.handleBookingDateChanges(value, visible, 'approvedAt')}
                                          visible={this.state.approvedDatePickerVisible}
                                        />
                                      </Grid.Column>
                                    </Grid>) : null
                                }
                                {data.statusID === 'sold_spa_signed' ? <RenderDivider /> : null}
                                {
                                  data.statusID === 'sold_spa_signed' ? (
                                    <Grid verticalAlign="middle">
                                      <Grid.Column textAlign="left" width={6}>
                                        <b>{translateModels(t, 'lastSoldAt', 'booking')}</b>
                                      </Grid.Column>
                                      <Grid.Column textAlign="right" width={10}>
                                        {
                                          isEditing && allowEditingSoldDate ? (
                                            <Form.Input
                                              fluid
                                              placeholder={t('Click to set last sold at date')}
                                              value={data.lastSoldAt ? moment(data.lastSoldAt).format(inputDateFormat) : ''}
                                              readOnly
                                              onFocus={() => this.handleOnVisible('lastSoldAt')}
                                              icon="calendar"
                                            />
                                          ) : null
                                        }
                                        {
                                          (isEditing && !allowEditingSoldDate) || !isEditing ? (
                                            data.lastSoldAt ? (
                                              <Timestamp
                                                format="DD MMM YYYY"
                                                timestamp={moment(data.lastSoldAt).format()}
                                              />
                                            ) : '-'
                                          ) : null
                                        }
                                      </Grid.Column>
                                    </Grid>
                                    ) : null
                                }
                                {
                                  data.statusID === 'sold_spa_signed' && isEditing && allowEditingSoldDate ? (
                                    <Grid>
                                      <Grid.Column width={16}>
                                        <CalendarDatePicker
                                          closeableCompact={false}
                                          minDate={this.state.minSoldDate}
                                          maxDate={moment().toDate()}
                                          noPadding
                                          name="lastSoldAt"
                                          value={data.lastSoldAt ? moment(data.lastSoldAt).toDate() : null}
                                          onChange={(value, visible) => this.handleBookingDateChanges(value, visible, 'lastSoldAt')}
                                          visible={this.state.soldDatePickVisible}
                                        />
                                      </Grid.Column>
                                    </Grid>) : null
                                }
                                {
                                  data.statusID === 'sold_spa_signed' ? (
                                    <div>
                                      <RenderDivider />
                                      <Grid verticalAlign="middle">
                                        <Grid.Column textAlign="left" width={6}>
                                          <b>{translateModels(t, 'spaSigningDate', 'booking')}</b>
                                        </Grid.Column>
                                        <Grid.Column textAlign="right" width={10}>
                                          { allowEditingSPADates && isEditing ? (
                                            <Form.Input
                                              fluid
                                              placeholder={t('Click to set SPA signing date')}
                                              value={data.spaSigningDate ? moment(data.spaSigningDate).format(inputDateFormat) : ''}
                                              readOnly
                                              onFocus={() => this.handleOnVisible('spaSigningDate')}
                                              icon="calendar"
                                            />
                                          )
                                          : data.spaSigningDate ? (
                                            <Timestamp
                                              format="DD MMM YYYY"
                                              timestamp={data.spaSigningDate}
                                            />
                                          ) : '-' }
                                        </Grid.Column>
                                      </Grid>
                                    </div>
                                  ) : null
                                }
                                { isEditing && allowEditingSPADates && data.statusID === 'sold_spa_signed' ? (
                                  <Grid>
                                    <Grid.Column width={16}>
                                      <CalendarDatePicker
                                        closeableCompact={false}
                                        minDate={this.state.minSoldDate}
                                        maxDate={moment().toDate()}
                                        noPadding
                                        name="spaSigningDate"
                                        value={data.spaSigningDate ? moment(data.spaSigningDate).toDate() : null}
                                        onChange={(value, visible) => this.handleBookingDateChanges(value, visible, 'spaSigningDate')}
                                        visible={this.state.spaSigningDatePickerVisible}
                                      />
                                    </Grid.Column>
                                  </Grid>
                                ) : null }
                                {
                                  data.statusID === 'sold_spa_signed' ? (
                                    <div>
                                      <RenderDivider />
                                      <Grid verticalAlign="middle">
                                        <Grid.Column textAlign="left" width={6}>
                                          <b>{translateModels(t, 'spaStampingDate', 'booking')}</b>
                                        </Grid.Column>
                                        <Grid.Column textAlign="right" width={10}>
                                          { allowEditingSPADates && isEditing ? (
                                            <Form.Input
                                              fluid
                                              placeholder={t('Click to set SPA stamping date')}
                                              value={data.spaStampingDate ? moment(data.spaStampingDate).format(inputDateFormat) : ''}
                                              readOnly
                                              onFocus={() => this.handleOnVisible('spaStampingDate')}
                                              icon="calendar"
                                            />
                                          )
                                          : data.spaStampingDate ? (
                                            <Timestamp
                                              format="DD MMM YYYY"
                                              timestamp={data.spaStampingDate}
                                            />
                                          ) : '-'
                                        }
                                        </Grid.Column>
                                      </Grid>
                                    </div>
                                  ) : null
                                }
                                { isEditing && allowEditingSPADates && data.statusID === 'sold_spa_signed' ? (
                                  <Grid>
                                    <Grid.Column width={16}>
                                      <CalendarDatePicker
                                        closeableCompact={false}
                                        minDate={this.state.minSoldDate}
                                        maxDate={moment().toDate()}
                                        noPadding
                                        name="spaStampingDate"
                                        value={data.spaStampingDate ? moment(data.spaStampingDate).toDate() : null}
                                        onChange={(value, visible) => this.handleBookingDateChanges(value, visible, 'spaStampingDate')}
                                        visible={this.state.spaStampingDatePickerVisible}
                                      />
                                    </Grid.Column>
                                  </Grid>
                                ) : null }
                                {data.statusID === 'cancelled_developer' ? <RenderDivider /> : null}
                                {
                                  data.statusID === 'cancelled_developer' ? (
                                    <Grid verticalAlign="middle">
                                      <Grid.Column textAlign="left" width={6}>
                                        <b>{translateModels(t, 'cancelledAt', 'booking')}</b>
                                      </Grid.Column>
                                      <Grid.Column textAlign="right" width={10}>
                                        {
                                          isEditing && allowEditingCancelledDate ? (
                                            <Form.Input
                                              fluid
                                              placeholder={t('Click to set cancelled date')}
                                              value={data.cancelledAt ? moment(data.cancelledAt).format(inputDateFormat) : ''}
                                              readOnly
                                              onFocus={() => this.handleOnVisible('cancelledAt')}
                                              icon="calendar"
                                            />
                                          ) : null
                                        }
                                        {
                                          (isEditing && !allowEditingCancelledDate) || !isEditing ? (
                                            data.cancelledAt ? (
                                              <Timestamp
                                                format="DD MMM YYYY"
                                                timestamp={moment(data.cancelledAt).format()}
                                              />
                                            ) : '-'
                                          ) : null
                                        }
                                      </Grid.Column>
                                    </Grid>
                                    ) : null
                                }
                                {
                                  data.statusID === 'cancelled_developer' && isEditing && allowEditingCancelledDate ? (
                                    <Grid>
                                      <Grid.Column width={16}>
                                        <CalendarDatePicker
                                          closeableCompact={false}
                                          minDate={this.state.minCancelledDate}
                                          maxDate={moment().toDate()}
                                          noPadding
                                          name="cancelledAt"
                                          value={data.cancelledAt ? moment(data.cancelledAt).toDate() : null}
                                          onChange={(value, visible) => this.handleBookingDateChanges(value, visible, 'cancelledAt')}
                                          visible={this.state.cancelledDatePickerVisible}
                                        />
                                      </Grid.Column>
                                    </Grid>) : null
                                }
                                {
                                  data.statusID === 'cancelled_developer' &&
                                    data.cancellationReasonID !== '' &&
                                    cancellationReasons.some(x => x.id === data.cancellationReasonID) ? (
                                      <div>
                                        <RenderDivider />
                                        <Grid verticalAlign="middle">
                                          <Grid.Column textAlign="left" width={6}>
                                            <b>{translateModels(t, 'cancellationReasonID', 'booking')}</b>
                                          </Grid.Column>
                                          <Grid.Column textAlign="right" width={10}>
                                            {
                                            isEditing ?
                                              <Form.Select
                                                fluid
                                                name="cancellationReasonID"
                                                options={cancellationReasons.map(d => ({
                                                  text: d.name,
                                                  value: d.id,
                                                }))}
                                                onChange={this.handleBookingChange}
                                                selectOnBlur={false}
                                                value={data.cancellationReasonID}
                                              />
                                              : cancellationReasons.find(x => x.id === data.cancellationReasonID).name
                                          }
                                          </Grid.Column>
                                        </Grid>
                                      </div>
                                  ) : null
                                }
                                {
                                  ((data.selectedBankCaseID && data.selectedBankCaseID !== 0) || data.bankName || (isEditing && this.canEditConversionDetails())) ? (
                                    <div>
                                      <RenderDivider />
                                      <Grid verticalAlign="middle">
                                        <Grid.Column textAlign="left" width={6}>
                                          <b>{t('Successful Loan')}</b>
                                        </Grid.Column>
                                        <Grid.Column textAlign="right" width={10}>
                                          {
                                            isEditing && this.canEditConversionDetails() ? (
                                              <Form.Input
                                                name="bankName"
                                                value={data.bankName}
                                                onChange={this.handleBookingChange}
                                                placeholder={t('Enter bank name')}
                                              />
                                            ) : (
                                              this.getSelectedBank()
                                            )
                                          }
                                        </Grid.Column>
                                      </Grid>
                                    </div>
                                  ) : null
                                }
                                {
                                  (data.bankerName || (isEditing && this.canEditConversionDetails())) ? (
                                    <div>
                                      <RenderDivider />
                                      <Grid verticalAlign="middle">
                                        <Grid.Column textAlign="left" width={6}>
                                          <b>{translateModels(t, 'bankerName', 'booking')}</b>
                                        </Grid.Column>
                                        <Grid.Column textAlign="right" width={10}>
                                          {
                                            isEditing && this.canEditConversionDetails() ? (
                                              <Form.Input
                                                name="bankerName"
                                                value={data.bankerName}
                                                onChange={this.handleBookingChange}
                                                placeholder={t('Enter banker name')}
                                              />
                                            ) : (
                                              data.bankerName
                                            )
                                          }
                                        </Grid.Column>
                                      </Grid>
                                    </div>
                                  ) : null
                                }
                                {
                                  (data.loanAmount > 0 || (isEditing && this.canEditConversionDetails())) ? (
                                    <div>
                                      <RenderDivider />
                                      <Grid verticalAlign="middle">
                                        <Grid.Column textAlign="left" width={6}>
                                          <b>{t('Loan Margin')}</b>
                                        </Grid.Column>
                                        <Grid.Column textAlign="right" width={10}>
                                          {
                                            isEditing && this.canEditConversionDetails() ? (
                                              <Form.Select
                                                fluid
                                                search
                                                name="loanMargin"
                                                options={this.getPercentageOptions()}
                                                placeholder="0%"
                                                selectOnBlur={false}
                                                value={data.loanAmount > 0 && data.spaValue > 0 ? Math.ceil((data.loanAmount / data.spaValue) * 100) : 0}
                                                onChange={this.handleLoanMarginChange}
                                              />
                                            ) : (
                                              data.loanAmount > 0 && data.spaValue > 0 ? `${Math.ceil((data.loanAmount / data.spaValue) * 100)}%` : '0%'
                                            )
                                          }
                                        </Grid.Column>
                                      </Grid>
                                    </div>
                                  ) : null
                                }
                                {
                                  (data.loanAmount > 0 || (isEditing && this.canEditConversionDetails())) ? (
                                    <div>
                                      <RenderDivider />
                                      <Grid verticalAlign="middle">
                                        <Grid.Column textAlign="left" width={6}>
                                          <b>{t('Loan Amount')}</b>
                                        </Grid.Column>
                                        <Grid.Column textAlign="right" width={10}>
                                          {
                                            isEditing && this.canEditConversionDetails() ? (
                                              <AppForm.Input
                                                name="loanAmount"
                                                type="number"
                                                min="0"
                                                value={data.loanAmount || 0}
                                                onChange={this.handleLoanAmountChange}
                                                step="1"
                                              />
                                            ) : (
                                              <LoanAmount
                                                projectCurrencies={data.project && data.project.projectCurrency ? data.project.projectCurrency : []}
                                                format="0,000,000.00"
                                                amount={data.loanAmount || 0}
                                                prefix={<CurrencySymbol />}
                                              />
                                            )
                                          }
                                        </Grid.Column>
                                      </Grid>
                                    </div>
                                  ) : null
                                }
                              </Form>
                            </Grid.Column>
                          </Grid.Row>

                          {/* Custom Fields */}
                          <Grid.Row>
                            <Grid.Column width={16}>
                              {projectBookingCustomFields && projectBookingCustomFields.length > 0 ?
                                <AppForm onSubmit={this.handleUpdateBooking}>
                                  {this.renderCustomFields(isEditing)}
                                </AppForm>
                                : ''
                              }
                              <Divider className="computer-hide hidden compact" />
                            </Grid.Column>
                          </Grid.Row>

                        </Grid>
                      </Grid.Column>

                      {/* APIs Section For Expanded Mode */
                        (this.canRenderNotesAndAPISection() && bookingNotesModuleExpand) ?
                          <Grid.Column mobile={16} tablet={7} computer={5}>
                            {this.renderAPISection(t, oriData, isEditing)}
                          </Grid.Column>
                          : ''
                      }

                      {/* Second / Right Parent Section (Notes & APIs) */
                        this.canRenderNotesAndAPISection() ?
                          (
                            <Grid.Column id="bn_grid_col_div" className={bookingNotesModuleExpand ? 'bn-section-expanded' : ''} mobile={16} tablet={bookingNotesModuleExpand ? 16 : 7} computer={bookingNotesModuleExpand ? 16 : 5}>
                              { /* Booking Notes */
                                this.hasBookingNoteReadAccess(data.project) ?
                                  (<BookingNote
                                    bookingID={data.id === routeParamsID ? routeParamsID : ''}
                                    defaultPrivacy={(data && data.project && data.project.bnDefaultPrivacy) || ''}
                                    hasEditAccess={this.hasBookingNoteWriteAccess(data.project)}
                                    isDisabled={this.state.editingBooking}
                                    setRef={this.setRefBookingNote}
                                    token={this.props.token}
                                    onExpand={this.handleBookingNotesExpand}
                                    showExpand={!this.props.isMobile}
                                  />)
                                  : ''
                              }

                              { /* APIs */
                                !bookingNotesModuleExpand ? this.renderAPISection(t, oriData, isEditing) : ''
                              }
                            </Grid.Column>
                          ) : ''
                      }
                    </Grid.Row>

                    {/* BookingNotes Expanded */}

                    {/* Booking Pricing Package */}
                    <Grid.Row>
                      <Grid.Column width={16}>
                        <BookingPricingPackage
                          availablePP={bookingPP}
                          data={oriData}
                          isEditing={isEditing}
                          onCheckRecalculate={this.handleRecalculatePackagePricing}
                          auth={this.props.auth}
                          globalSettings={globalSettings}
                          openModal={this.toggleActiveStates}
                        />
                      </Grid.Column>
                    </Grid.Row>

                    {/* Booking Fees Breakdown */}
                    <Grid.Row>
                      <Grid.Column width={16}>
                        <BookingFeePackage
                          availablePackages={bookingFP}
                          data={oriData}
                          isEditing={isEditing}
                          onCheckRecalculate={this.handleRecalculatePackagePricing}
                          auth={this.props.auth}
                          openModal={this.toggleActiveStates}
                        />
                      </Grid.Column>
                    </Grid.Row>

                    {/* Specifications */}
                    <Grid.Row>
                      <Grid.Column width={16}>
                        <SpecificationTable
                          headerNode={t('Booking Specifications')}
                          editable
                          type="bookings"
                          isEditing={isEditing}
                          hideButton
                          data={data.specifications}
                          loading={this.state.loading}
                          onChange={this.handleBookingSpecificationChange}
                        />
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                )}
              />
            </Grid.Column>
          </Grid.Row>
          { !this.showVNPaymentSection() && (
            <Grid.Row>
              <Grid.Column>
                <BookingPayment
                  disabled={editingBooking}
                  fetchNewBooking={this.props.fetchNewBooking}
                  token={this.props.token}
                  checkChanges={this.handleCheckChanges}
                  resetChanges={this.handleResetCheck}
                  updateBookingPayment={this.handleUpdatePayment}
                  data={data}
                  defaultBookingFeeAmount={data.project.defaultBookingFeeAmount}
                />
              </Grid.Column>
            </Grid.Row>
          )}
          { data.bookingAttachments && data.bookingAttachments.length > 0 ?
            <Grid.Row>
              <Grid.Column>
                <BookingAttachment
                  onRef={(ref) => { this.bookingAttachment = ref; }}
                  data={data}
                  onSubmit={file => this.getDocumentToken(() => this.uploadAttachments(file))}
                  onDelete={fileID => this.getDocumentToken(() => this.deleteAttachment(fileID))}
                  isMobile={this.props.isMobile}
                  uploadModalState={uploadModalState}
                  loading={this.state.loading}
                />
              </Grid.Column>
            </Grid.Row>
            : ''
          }
        </Grid>
      </Container>
    );
  }
}

export default withTranslation([
  ...namespaces,
  TRANSLATION_FILES.models.booking,
  TRANSLATION_FILES.models.mpUserDetails,
])(connect(Info.mapStateToProps)(Info));



// WEBPACK FOOTER //
// ./src/containers/Bookings/Overview/Info.jsx